// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-29T17:39:45.163Z
// Property: The Century (ID: 6767906449164267)
// Collections: 48 amenities, 46 floorplans (live), 20 photos, 65 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162415",
  "multihub_property_id": "6767906449164267",
  "property_external_id": "224750",
  "property_zillow_url": "https://www.zillow.com/apartments/seattle-wa/the-century/63Px5N/",
  "property_apartments_url": "https://www.apartments.com/101-taylor-ave-n-seattle-wa-98109/1956pp6/",
  "property_google_business_url": "https://www.google.com/maps?cid=3670409725330938482",
  "property_linkedin_url": null,
  "property_hubspot_id": "49265269316",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-century",
  "property_name": "The Century",
  "property_website_url": "https://www.thecenturyseattle.com",
  "property_domain": "https://www.thecenturyseattle.com",
  "property_address": "101 Taylor Ave N.",
  "property_full_address": "101 Taylor Ave N, Seattle, WA 98109",
  "property_address_1": "101 Taylor Avenue North",
  "property_address_2": null,
  "property_address_city": "Seattle",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98109",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "South Lake Union",
  "property_address_latitude": "47.6190381",
  "property_address_longitude": "-122.346812",
  "property_email": "Info@thecenturyseattle.com",
  "property_phone": "(844) 262-6352",
  "property_call_tracking_phone": "844-894-0444",
  "property_company_name": "Pillar Properties",
  "property_company_url": "https://www.pillarproperties.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Century, where modern comfort meets urban elegance in Seattle, WA. Choose from a range of stylish floor plans, each featuring premium finishes and pet-friendly spaces. Enjoy stunning rooftop views, a BBQ grill, and cozy fire pits, alongside unique amenities like a bicycle workspace and high-tech theater. Your vibrant community awaits!",
  "property_long_description": "The Century is at the epicenter of the best that Seattle has to offer. Next to the Seattle Center and minutes from downtown Seattle, the waterfront, South Lake Union, Queen Anne and Belltown, The Century is also close to Amazon's global headquarters, top restaurants and vibrant retail. The Space Needle is so close it feels like you can reach out and touch it. The Century is honored to be recognized as the Community of the Year by the Washington State Multi-Family Housing Association.The spacious apartments at The Century feature high end finishes, tall ceilings, large kitchens and bathrooms, air conditioning, private patios along with an expansive roof top deck, fitness center and high tech theater.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-53e3-7019-88ef-b72c478abfed.webp",
  "property_featured_image_media": {
    "alt_text": "Modern apartment building with the Space Needle in the background at dusk.",
    "public_id": "019d0812-53e3-7019-88ef-b72c478abfed",
    "storage_key": "property/6767906449164267/019d0812-53e3-7019-88ef-b72c478abfed.webp",
    "width": 1000,
    "height": 594
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "258",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "97",
  "property_transit_score": "95",
  "property_business_hours_list": null,
  "property_current_occupancy": "96.89922480620154",
  "property_admin_fee": null,
  "property_application_fee": "45",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "180",
  "property_pet_restrictions": "Max 2 allowed; No weight limit.",
  "property_pet_policy_description": "Pets - allowed | Max 2 allowed | Deposit (refundable): $300 | Rent: $50 Comments: No weight limit. . Additional Rent of $50.00 per pet. Cats allowed Dogs allowed",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://thecenturyseattle.securecafe.com/onlineleasing/the-century/floorplans.aspx",
  "property_resident_portal_url": "https://thecenturyseattle.securecafenet.com/residentservices/the-century/userlogin",
  "property_apply_now_url": "https://thecenturyseattle.securecafe.com/onlineleasing/the-century/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-5743-760a-9ccc-6eb31cc778b5.webp",
  "property_primary_logo_media": {
    "alt_text": "The Century logo.",
    "public_id": "019d0813-5743-760a-9ccc-6eb31cc778b5",
    "storage_key": "property/6767906449164267/019d0813-5743-760a-9ccc-6eb31cc778b5.webp",
    "width": 350,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0815-0fa2-7049-bc92-17aab0aca8f8.webp",
  "property_secondary_logo_media": {
    "alt_text": "Black square",
    "public_id": "019d0815-0fa2-7049-bc92-17aab0aca8f8",
    "storage_key": "property/6767906449164267/019d0815-0fa2-7049-bc92-17aab0aca8f8.webp",
    "width": 5,
    "height": 5
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019db06e-6c20-7465-ba4f-577429bfa212.webp",
  "property_fav_icon_media": {
    "alt_text": "The Century logo",
    "public_id": "019db06e-6c20-7465-ba4f-577429bfa212",
    "storage_key": "property/6767906449164267/019db06e-6c20-7465-ba4f-577429bfa212.webp",
    "width": 299,
    "height": 136
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0815-1a5e-73bd-9961-a1ea7f545456.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Century logo",
    "public_id": "019d0815-1a5e-73bd-9961-a1ea7f545456",
    "storage_key": "property/6767906449164267/019d0815-1a5e-73bd-9961-a1ea7f545456.webp",
    "width": 350,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0815-231d-710e-9c75-0a76c63281c5.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Century logo",
    "public_id": "019d0815-231d-710e-9c75-0a76c63281c5",
    "storage_key": "property/6767906449164267/019d0815-231d-710e-9c75-0a76c63281c5.webp",
    "width": 350,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d06cf-26f9-7551-948c-1245b11c8422.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
  "property_company_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc2-1eb8-7554-8d89-d3424651cf63",
    "storage_key": "company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
    "width": 189,
    "height": 128
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-9029-7028-b531-c3ae9dacde22",
    "storage_key": "company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
    "width": 178,
    "height": 122
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-00d2-7093-a184-b3de0f0bba5a",
    "storage_key": "company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
    "width": 178,
    "height": 122
  },
  "property_primary_color": "#00B3E6",
  "property_secondary_color": "#F47B4B",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#808284",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "588 - 1074",
  "property_sqft_min": "588",
  "property_sqft_max": "1074",
  "property_price_range": "2645 - 5015",
  "property_price_min": "2645",
  "property_price_max": "5015",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/thecenturyseattle",
  "property_instagram_url": "https://www.instagram.com/thecenturyseattle",
  "property_twitter_url": "https://x.com/TheCenturySea",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJHW4sykgVkFQRclp90jLq7zI",
  "property_youtube_url": "https://www.youtube.com/watch?v=IoXpuAMEAcA",
  "property_yelp_url": "https://www.yelp.com/biz/the-century-seattle",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Century",
  "property_home_romance_title": "Step into Your Dream Life Today at Our Charming Community",
  "property_home_amenities_blurb": "Welcome to The Century, where modern living meets breathtaking views! Choose from stylish studio to spacious three-bedroom apartments, each designed with upscale finishes. Enjoy our rooftop deck complete with a BBQ grill and fire pit, or unwind in our high-tech theater. Your vibrant Seattle lifestyle begins here—experience it today!",
  "property_home_floorplans_blurb": "Welcome to The Century in vibrant Seattle, WA! Choose from stylish studio, one, two, or three-bedroom floor plans designed for modern living. With thoughtful layouts and elegant finishes, your ideal home awaits. Browse our available apartments today and step into a world where comfort meets urban chic!",
  "property_home_gallery_blurb": "Welcome to The Century in Seattle, WA, where urban living meets serene comfort. From our stunning rooftop deck featuring breathtaking views of the Space Needle to pet-friendly amenities like a dog run and paw spa, your dream lifestyle awaits. Picture yourself here, indulging in luxury and convenience every day!",
  "property_home_neighborhood_blurb": "At The Century in Seattle, your perfect home awaits, from cozy studios to spacious three-bedroom layouts. Nestled near vibrant parks, elite universities, and renowned attractions like T-Mobile Park and the Seattle Aquarium, our community embodies the essence of urban living. Uncover the richness of nearby culture and recreation.",
  "property_home_reviews_blurb": "At The Century in Seattle, residents rave about our friendly staff and vibrant community events. One happy tenant noted, \"The building is well maintained, and the staff is friendly and responsive.\" With a supportive team and a convenient location, experience the exceptional lifestyle that makes living here so enjoyable!",
  "property_neighborhood_blurb": "Nestled in the heart of Seattle, The Century offers unparalleled access to cultural landmarks and vibrant community spots. From the breathtaking views at Kerry Park to the tranquil paths of Discovery Park, our location maximizes your experience—balancing city excitement with nature's embrace. See what's around our community and feel the rhythm of Seattle.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Elevate your living experience at The Century in Seattle! Enjoy stunning rooftop views, relax by the fire pit, or unleash your creativity with our bicycle work space. Our pet-friendly apartments feature modern finishes, energy-efficient appliances, and unique amenities that redefine comfort. Your vibrant lifestyle awaits—check out our exceptional amenities today!",
  "property_applynow_blurb": "Elevate your lifestyle at The Century in Seattle, where modern living meets stunning views. Choose from a variety of floor plans, including spacious studios and three-bedroom layouts. Enjoy rooftop lounging, electric car charging, and pet-friendly amenities while indulging in luxurious finishes. Secure your new home and lease online today!",
  "property_contactus_blurb": "At The Century in Seattle, WA, your ideal living space awaits with thoughtfully designed studio, one, two, and three-bedroom floor plans. Each layout harmonizes style and comfort, offering a sanctuary you’ll love. Have questions? Reach out to our leasing team today to find your perfect home!",
  "property_faqs_blurb": "At The Century in vibrant Seattle, WA, we cater to all lifestyles with diverse floor plans—studio to three-bedroom options. Curious about our community? Dive into our FAQs page for insights on amenities, leasing, and more. Your perfect home awaits!",
  "property_floorplans_blurb": "At The Century in Seattle, WA, your dream apartment awaits! Our diverse floor plans—ranging from cozy studios to spacious three-bedrooms—cater to every lifestyle. Browse through our unique designs and envision your new life in a community that seamlessly combines comfort and style. Your perfect home is just a click away!",
  "property_gallery_blurb": "At The Century in Seattle, picture yourself in stylish apartments, from cozy studios to spacious three-bedrooms. Elevate your lifestyle with amenities like a rooftop deck featuring stunning views, a high-tech theater, and a paw spa for your furry friends. Experience urban living with a dash of comfort and luxury!",
  "property_interactivemap_blurb": "At The Century in Seattle, our diverse floor plans cater to your lifestyle, from cozy studios to spacious three-bedrooms. Enjoy stunning views from the rooftop deck, unwind by the fire pit, or get active with amenities like a bike workspace and dog run. Use our interactive community map to find your perfect home!",
  "property_pets_blurb": "At The Century in Seattle, your pets are part of the family. With no weight limit and a welcoming atmosphere, your furry companions will thrive here. Enjoy scenic city views and spacious living while indulging in pet-friendly amenities, making every day a tail-wagging adventure!",
  "property_referafriend_blurb": "At The Century in vibrant Seattle, WA, our diverse floor plans—ranging from cozy studios to spacious three-bedrooms—cater to every lifestyle. Enrich your living experience by inviting friends to join our welcoming community. Great friends make great neighbors—refer a friend today and enjoy life together at The Century!",
  "property_residentaccess_blurb": "Welcome to The Century in Seattle, WA, where your perfect home awaits! Choose from thoughtfully designed studio, one, two, and three-bedroom apartments tailored to your lifestyle. Access your resident portal now to simplify rent payments, schedule maintenance, and more—experience convenience at your fingertips!",
  "property_reviews_blurb": "At The Century in Seattle, residents rave about the exceptional service and vibrant community atmosphere. With a “friendly and responsive” staff and exciting events nearly every week, it’s no wonder so many choose to call this well-maintained property home. See what our residents have to say about living at our community!",
  "property_created_at": "1743797426055",
  "property_scheduletour_blurb": "At The Century in Seattle, WA, our diverse floor plans—ranging from cozy studios to spacious three-bedroom apartments—cater to every lifestyle. Schedule a tour today and experience the vibrant community. Curious about resident life? Check out their glowing testimonials and envision your new home with us!",
  "property_thankyou_blurb": "Thank you for reaching out to The Century in vibrant Seattle, WA! Choose from stylish studio, one-, two-, or three-bedroom floor plans designed for comfort and convenience. A member of our team will contact you shortly to help you find your perfect home. Your ideal Seattle lifestyle awaits!",
  "property_virtualtours_blurb": "Experience urban living at The Century in Seattle, WA, where we offer thoughtfully designed studio, one-, two-, and three-bedroom apartments. Each space blends style with comfort, perfectly suited for your lifestyle. Ready to envision your new home? Take a virtual tour of our vibrant community and see for yourself!",
  "property_copyright": "All Rights Reserved. The Century",
  "property_seo_title_home": "The Century |  Apartments in Seattle, WA",
  "property_seo_description_home": "Experience modern living at The Century in Seattle. Enjoy stunning rooftop views, pet-friendly amenities, and stylish floor plans tailored for you.",
  "property_seo_title_floorplans": "Floor Plans | Seattle, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Century in Seattle! From cozy studios to spacious three-bedrooms, discover the perfect floor plan for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Seattle, WA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at The Century! Enjoy rooftop BBQs, an ultra-modern theater, pet-friendly perks, and stunning views in the heart of Seattle.",
  "property_seo_title_gallery": "Gallery | Apartments in Seattle, WA",
  "property_seo_description_gallery": "Enjoy Seattle skyline views at The Century! Our pet-friendly apartments feature modern amenities, rooftop relaxation, and a vibrant community.",
  "property_seo_title_virtualtours": "Virtual Tours | The Century Apartments",
  "property_seo_description_virtualtours": "Experience The Century in Seattle! Take a virtual tour of our studio, one, two, and three-bedroom apartments—your dream home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Century Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at The Century in Seattle! Check our map for studios to three-bedrooms & enjoy premium amenities with stunning views.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Seattle, WA",
  "property_seo_description_neighborhood": "Uncover Seattle living at The Century! Dive into local favorites and vibrant hotspots just steps from your door. Your new adventure awaits!",
  "property_seo_title_contact": "Contact Us | The Century",
  "property_seo_description_contact": "Connect with The Century in Seattle! From cozy studios to spacious three-bedrooms, our leasing team is ready to assist with your perfect home. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Seattle, WA",
  "property_seo_description_faqs": "Uncover answers to your questions at The Century in Seattle! From floor plans to amenities, our FAQs page has everything you need for your new home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Seattle, WA",
  "property_seo_description_reviews": "At The Century in Seattle, enjoy stunning views, modern amenities, and a pet-friendly lifestyle. Hear from residents and join our community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Seattle, WA",
  "property_seo_description_applynow": "Discover your ideal home at The Century in Seattle! Enjoy rooftop views, pet-friendly amenities, and modern designs. Lease online now!",
  "property_seo_title_residentaccess": "Resident Access | The Century",
  "property_seo_description_residentaccess": "Login to The Century's resident portal in Seattle! Manage rent, request maintenance, and enjoy easy access to your community features—all at your fingertips.",
  "property_seo_title_referafriend": "Refer A Friend | The Century",
  "property_seo_description_referafriend": "At The Century in Seattle, strong friendships blossom. Refer a friend and enjoy exclusive perks together! Join our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Century",
  "property_seo_description_scheduletour": "Experience urban living at The Century in Seattle. Schedule your tour today and uncover a vibrant community where comfort and style meet. Your new home awaits!",
  "property_seo_title_privacy": "Privacy Policy | The Century",
  "property_seo_description_privacy": "Protecting your information is our priority. Learn how we safeguard your data at The Century in Seattle. Your privacy matters—view our policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Century",
  "property_seo_description_accessibility": "At The Century in Seattle, we champion digital inclusion, ensuring everyone can navigate our apartment community with ease. Accessibility matters—join us!",
  "property_seo_title_sitemap": "Sitemap | The Century",
  "property_seo_description_sitemap": "Explore Seattle's vibrant Century community! Check our sitemap for easy access to exceptional amenities and floor plans tailored to your lifestyle.",
  "property_seo_title_thankyou": "Thank You | The Century",
  "property_seo_description_thankyou": "Thank you for reaching out to The Century in Seattle! Our team will connect soon to assist you in finding your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Seattle, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1783257894192",
  "amenities": [
    {
      "id": "ec_bfd64c5703837a295590c3ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748794",
      "title": "24 Hour Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f80417dc6701fce84d506428",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538335",
      "title": "Bike Racks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b3a71b765814aa4b3dfeb0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538339",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18a06695d9c9cdc212272504",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538341",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30b5e10a3d466c63b6968f6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538342",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_780335f93d074729f15898be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748770",
      "title": "Gated Electronic Entrance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa68e0aab43d83575950a84c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538344",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5541e0ac8c251631db35c70b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538346",
      "title": "Media Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25e02b6b1a8a18d7cef2f418",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748773",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c49a7d91cccc880f60a33bf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538348",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c547a96f988d99c10becf090",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748772",
      "title": "State of The Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edcb25540aae67debf5445a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748771",
      "title": "Underground Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_099ce52a95328a09e0183329",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "37348451",
      "title": "BBQ Grill on Roof Top Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_291b32770a6628595d6d61a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748768",
      "title": "Bicycle Work Space and Storage at The Spoke Shop for Residents",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4d198883fb8ebc41871bf71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "37348449",
      "title": "Car Care Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acdcf8838ef6151a4b159b02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748775",
      "title": "Close to Parks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_146c0ec3d6c06ba6001b38c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748796",
      "title": "Electric Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c00bc4ac083a28512595c0cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "37348450",
      "title": "Fire Pit on Roof Top Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a49fc9dfdcad90c47a2541e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748795",
      "title": "Garbage Chutes On Every Level",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a43cca88a1dc138e4fa65d47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748774",
      "title": "High Tech Theater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a22e7cfcc56a610f3a896509",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748776",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5797dc733651a9594f955bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748766",
      "title": "Pet Friendly Apartments w/Dog Run and Paw Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d58dd04af43c18b644ca2829",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748777",
      "title": "Recycling Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec5d97f6f4296b180b41ecdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748765",
      "title": "Roof Top Deck w/Views of the Space Needle, Puget Sound, Seattle and beyond",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdca97ef85037130f5f6f914",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748767",
      "title": "Two Resident Roof Top Lounges",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a818a365f60f998f7a1bfd85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748778",
      "title": "WiFi Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ef06cfd882497d17e0cafcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748769",
      "title": "Wine Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d07940c6afa2aee39eb93cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748840",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f1707d0317cfee3f1586911",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538336",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cbf86b978e478c1886f01c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538337",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d09b2064709e3875d805e05b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538338",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6d61e2a9f16f690bc6c0d57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538340",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bac170761219790928794cb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748842",
      "title": "Front Load Washer/Dryer in Every Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b63c19b6e101acf7f558cbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538343",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7a28c52ae437e06112dc2cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538345",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35eb17066d50576cfe765b92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538347",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_181ef5a475899105b25d7479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748834",
      "title": "Private Patios and Balconies*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6c44fb6964398650cd55a64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538349",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8753fc05d8ebf27f5410a489",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748841",
      "title": "Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0833e5362f3a67bfc1d7e73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "45538350",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a96a1905df010ec80e67e5c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748835",
      "title": "Custom Self-Closing Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d1538b5583864aa6055f43c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748837",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d80f7b9821680304cd80228c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748838",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7c61c744807ce42bd775759",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748836",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bdfb370c5ab53d977e57425",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748839",
      "title": "Sunken Kitchen Sinks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53a93dc1ede3237d82fa1adc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748845",
      "title": "Tile Backsplashes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f4658ba3b65d026bafe6205",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748843",
      "title": "Vessel Bathroom Sinks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a339cadc6663df752998e19e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "yardi",
      "external_id": "36748844",
      "title": "Walk-in Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_bfd426e860a42186a647095c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-53e3-7019-88ef-b72c478abfed.webp",
      "image_media": {
        "alt_text": "Modern apartment building with the Space Needle in the background at dusk.",
        "public_id": "019d0812-53e3-7019-88ef-b72c478abfed",
        "storage_key": "property/6767906449164267/019d0812-53e3-7019-88ef-b72c478abfed.webp",
        "width": 1000,
        "height": 594
      },
      "title": "Community",
      "description": "Experience city living with stunning views of the Space Needle from your doorstep. This modern apartment complex offers a prime location and stylish design.",
      "link": "false",
      "alt_text": "Modern apartment building with the Space Needle in the background at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Exterior with Space Needle.jpg"
    },
    {
      "id": "ec_8d1f8a8730f470a736d66e13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-535a-71f8-aff7-440e0dad9d01.webp",
      "image_media": {
        "alt_text": "Modern living room with a blue sofa, armchair, and large window with city view.",
        "public_id": "019d0812-535a-71f8-aff7-440e0dad9d01",
        "storage_key": "property/6767906449164267/019d0812-535a-71f8-aff7-440e0dad9d01.webp",
        "width": 1000,
        "height": 594
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a plush blue sofa, accent armchair, and a large window offering picturesque city views.",
      "link": "false",
      "alt_text": "Modern living room with a blue sofa, armchair, and large window with city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Interiors.jpg"
    },
    {
      "id": "ec_0e88ae0ffc86fba2ab02b5fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-5d5d-75d9-9c5a-f8f32795471e.webp",
      "image_media": {
        "alt_text": "Rooftop deck with Space Needle view and people relaxing at sunset.",
        "public_id": "019d0812-5d5d-75d9-9c5a-f8f32795471e",
        "storage_key": "property/6767906449164267/019d0812-5d5d-75d9-9c5a-f8f32795471e.webp",
        "width": 2319,
        "height": 3072
      },
      "title": "Community",
      "description": "Enjoy breathtaking views of the Space Needle and the city skyline from our rooftop deck. Perfect for evening relaxation or entertaining guests.",
      "link": "false",
      "alt_text": "Rooftop deck with Space Needle view and people relaxing at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Century - Rooftop Deck.jpg"
    },
    {
      "id": "ec_0b79d7d6612a56db15137260",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-55d4-7799-915b-76b0c77674a9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and an island with seating.",
        "public_id": "019d0812-55d4-7799-915b-76b0c77674a9",
        "storage_key": "property/6767906449164267/019d0812-55d4-7799-915b-76b0c77674a9.webp",
        "width": 612,
        "height": 408
      },
      "title": "Apartment",
      "description": "Beautifully designed kitchen featuring dark wood cabinetry, a striking mosaic backsplash, and a spacious island perfect for dining or entertaining. Modern stainless steel appliances complete this stylish space.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and an island with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Century - Kitchen.png"
    },
    {
      "id": "ec_2b0b9aa2094fb6cdd90de08d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-6193-711c-ba1d-de2b90385478.webp",
      "image_media": {
        "alt_text": "Modern apartment living and dining area with a kitchen island and seating.",
        "public_id": "019d0812-6193-711c-ba1d-de2b90385478",
        "storage_key": "property/6767906449164267/019d0812-6193-711c-ba1d-de2b90385478.webp",
        "width": 1795,
        "height": 1113
      },
      "title": "Apartment",
      "description": "Stylish and functional open-concept living space featuring a modern kitchen with stainless steel appliances, a comfortable living area, and a dining nook perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern apartment living and dining area with a kitchen island and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Century - Interior.JPG"
    },
    {
      "id": "ec_485038261d5bc922c1a9874b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-6138-74fc-9efb-bb829eff7c09.webp",
      "image_media": {
        "alt_text": "Row of treadmills in a modern apartment gym with weight machines visible in background.",
        "public_id": "019d0812-6138-74fc-9efb-bb829eff7c09",
        "storage_key": "property/6767906449164267/019d0812-6138-74fc-9efb-bb829eff7c09.webp",
        "width": 1000,
        "height": 594
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Row of treadmills in a modern apartment gym with weight machines visible in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Fitness Center.jpg"
    },
    {
      "id": "ec_b0974b60fb5ec32f9990dd00",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-656f-758f-b69d-d0279e126d31.webp",
      "image_media": {
        "alt_text": "Rooftop dog park with Seattle Space Needle view.",
        "public_id": "019d0812-656f-758f-b69d-d0279e126d31",
        "storage_key": "property/6767906449164267/019d0812-656f-758f-b69d-d0279e126d31.webp",
        "width": 1000,
        "height": 594
      },
      "title": "Community",
      "description": "Enjoy our rooftop dog park with stunning city views, including the iconic Space Needle. A perfect spot for your furry friend.",
      "link": "false",
      "alt_text": "Rooftop dog park with Seattle Space Needle view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Rooftop Dog Run.jpg"
    },
    {
      "id": "ec_cc742ce0aa86704279ac34c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-80be-7789-98bf-b8ef07014602.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a laundry closet",
        "public_id": "019d0812-80be-7789-98bf-b8ef07014602",
        "storage_key": "property/6767906449164267/019d0812-80be-7789-98bf-b8ef07014602.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Apartment",
      "description": "In-unit laundry closet featuring a stacked washer and dryer for convenient apartment living.",
      "link": "false",
      "alt_text": "Stackable washer and dryer in a laundry closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/washer and dryer in every unit.JPG"
    },
    {
      "id": "ec_aa703e3b5237ca2b5184d01a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-711e-70d5-9340-71c87f8959e8.webp",
      "image_media": {
        "alt_text": "Rooftop patio seating with view of the Space Needle and city skyline.",
        "public_id": "019d0812-711e-70d5-9340-71c87f8959e8",
        "storage_key": "property/6767906449164267/019d0812-711e-70d5-9340-71c87f8959e8.webp",
        "width": 1731,
        "height": 1155
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from the rooftop patio, complete with comfortable seating and lush greenery. A perfect spot to relax and take in the iconic Seattle skyline.",
      "link": "false",
      "alt_text": "Rooftop patio seating with view of the Space Needle and city skyline.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Century - Rooftop Deck(2).jpg"
    },
    {
      "id": "ec_f086900f13a3ca0dc13f639b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-724f-7754-bb36-618752515c94.webp",
      "image_media": {
        "alt_text": "Modern apartment bedroom with a king-size bed, nightstand, and large window.",
        "public_id": "019d0812-724f-7754-bb36-618752515c94",
        "storage_key": "property/6767906449164267/019d0812-724f-7754-bb36-618752515c94.webp",
        "width": 1819,
        "height": 1099
      },
      "title": "Apartment",
      "description": "Relax in this serene apartment bedroom, featuring a comfortable king-size bed, stylish nightstand, and ample natural light from the large window. A cozy dog bed is also provided.",
      "link": "false",
      "alt_text": "Modern apartment bedroom with a king-size bed, nightstand, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Century - Bedroom.jpg"
    },
    {
      "id": "ec_a3d3a90949a1b9f7f35b843c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-7546-74bf-8748-acaba05bf593.webp",
      "image_media": {
        "alt_text": "View of city skyline and water at sunset from a balcony.",
        "public_id": "019d0812-7546-74bf-8748-acaba05bf593",
        "storage_key": "property/6767906449164267/019d0812-7546-74bf-8748-acaba05bf593.webp",
        "width": 1000,
        "height": 594
      },
      "title": "Community",
      "description": "Enjoy breathtaking city and water views from your private balcony. Experience urban living at its finest.",
      "link": "false",
      "alt_text": "View of city skyline and water at sunset from a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Apartment Views.jpg"
    },
    {
      "id": "ec_d598570eed2096e803711c56",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-7e23-7258-ad45-33ccaa2782e2.webp",
      "image_media": {
        "alt_text": "Modern galley kitchen with dark wood cabinetry, quartz countertops, and a mosaic tile backsplash.",
        "public_id": "019d0812-7e23-7258-ad45-33ccaa2782e2",
        "storage_key": "property/6767906449164267/019d0812-7e23-7258-ad45-33ccaa2782e2.webp",
        "width": 1000,
        "height": 594
      },
      "title": "Apartment",
      "description": "A sleek and contemporary galley kitchen featuring dark wood cabinets, sparkling quartz countertops, and a stylish mosaic tile backsplash. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern galley kitchen with dark wood cabinetry, quartz countertops, and a mosaic tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Kitchen.jpg"
    },
    {
      "id": "ec_870af9fa826d64d87271fd51",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-7f01-7068-8e7c-a45e5dfbf799.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with sink, toilet, and bathtub with shower curtain.",
        "public_id": "019d0812-7f01-7068-8e7c-a45e5dfbf799",
        "storage_key": "property/6767906449164267/019d0812-7f01-7068-8e7c-a45e5dfbf799.webp",
        "width": 1000,
        "height": 594
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a sleek vanity with ample counter space, a comfortable toilet, and a clean bathtub with a shower.",
      "link": "false",
      "alt_text": "Modern bathroom vanity with sink, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Bathroom.jpg"
    },
    {
      "id": "ec_b1be7992aec08dcf30baaea4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-82ec-74ea-92ac-c760e3b0371f.webp",
      "image_media": {
        "alt_text": "Theater-style seating with large screens showing a football game.",
        "public_id": "019d0812-82ec-74ea-92ac-c760e3b0371f",
        "storage_key": "property/6767906449164267/019d0812-82ec-74ea-92ac-c760e3b0371f.webp",
        "width": 1000,
        "height": 594
      },
      "title": "Community",
      "description": "Enjoy the game in our state-of-the-art theater room, complete with comfortable seating and multiple screens for an immersive viewing experience.",
      "link": "false",
      "alt_text": "Theater-style seating with large screens showing a football game.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Theatre.jpg"
    },
    {
      "id": "ec_a2b288f0541d8fd89c838b5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-8a60-72ef-a769-ff36065c674c.webp",
      "image_media": {
        "alt_text": "Rooftop patio with fire pit, seating, and planters.",
        "public_id": "019d0812-8a60-72ef-a769-ff36065c674c",
        "storage_key": "property/6767906449164267/019d0812-8a60-72ef-a769-ff36065c674c.webp",
        "width": 1000,
        "height": 594
      },
      "title": "Community",
      "description": "Enjoy the city views from our rooftop patio, complete with comfortable seating and a cozy fire pit.",
      "link": "false",
      "alt_text": "Rooftop patio with fire pit, seating, and planters.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Century - Rooftop Deck(1).jpg"
    },
    {
      "id": "ec_5874ba97a3c88b80fb0725de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-8d10-74de-8226-1f7174b0a7dc.webp",
      "image_media": {
        "alt_text": "Large park with a fountain and the Space Needle in the background.",
        "public_id": "019d0812-8d10-74de-8226-1f7174b0a7dc",
        "storage_key": "property/6767906449164267/019d0812-8d10-74de-8226-1f7174b0a7dc.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Enjoy the outdoors in this beautiful park, featuring a large fountain and iconic city views. Perfect for relaxation and community gatherings.",
      "link": "false",
      "alt_text": "Large park with a fountain and the Space Needle in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Neighborhood.jpg"
    },
    {
      "id": "ec_88746ab79ad5e40c899fda69",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-8f56-733e-9128-7d86c104b671.webp",
      "image_media": {
        "alt_text": "Dining area with a glass-top table and four upholstered chairs, overlooking a cityscape.",
        "public_id": "019d0812-8f56-733e-9128-7d86c104b671",
        "storage_key": "property/6767906449164267/019d0812-8f56-733e-9128-7d86c104b671.webp",
        "width": 3072,
        "height": 2425
      },
      "title": "Apartment",
      "description": "Enjoy your meals with a view in this elegant dining area. Features a glass-top table, four plush chairs, and a stunning cityscape backdrop through large windows and a balcony door.",
      "link": "false",
      "alt_text": "Dining area with a glass-top table and four upholstered chairs, overlooking a cityscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/DSC_7999.JPG"
    },
    {
      "id": "ec_7d243ad81e6082180c096bc3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-b054-777e-b172-07073af4758c.webp",
      "image_media": {
        "alt_text": "Man grilling on a rooftop patio with a city skyline view.",
        "public_id": "019d0812-b054-777e-b172-07073af4758c",
        "storage_key": "property/6767906449164267/019d0812-b054-777e-b172-07073af4758c.webp",
        "width": 3072,
        "height": 1892
      },
      "title": "Community",
      "description": "Enjoy rooftop grilling with stunning city views from our community amenities.",
      "link": "false",
      "alt_text": "Man grilling on a rooftop patio with a city skyline view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Century - Rooftop Grills.jpg"
    },
    {
      "id": "ec_faf953dd3654894f0d8ed561",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0812-aba1-76ef-a8ab-7562d553624a.webp",
      "image_media": {
        "alt_text": "Rooftop terrace with lounge chairs and tables, overlooking a city skyline at sunset.",
        "public_id": "019d0812-aba1-76ef-a8ab-7562d553624a",
        "storage_key": "property/6767906449164267/019d0812-aba1-76ef-a8ab-7562d553624a.webp",
        "width": 3072,
        "height": 2254
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from our expansive rooftop terrace, featuring comfortable lounge seating and dining areas, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Rooftop terrace with lounge chairs and tables, overlooking a city skyline at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Century - Rooftop Deck (2).jpg"
    },
    {
      "id": "ec_181db97ab827ce99ac14d3d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d09a0-a980-72bd-b851-561d8171bf01.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, soaking tub, and walk-in shower.",
        "public_id": "019d09a0-a980-72bd-b851-561d8171bf01",
        "storage_key": "property/6767906449164267/019d09a0-a980-72bd-b851-561d8171bf01.webp",
        "width": 2212,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Experience luxury in our modern bathrooms, featuring spacious double vanities, a deep soaking tub, and a sleek walk-in shower for ultimate relaxation.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, soaking tub, and walk-in shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Century - Bathroom.JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e565a147-459c-4310-b52a-151949d65e5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "University Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "2623 NE University Village St, Seattle, WA 98105, USA",
      "poi_short_description": "Upscale retail space showcasing shops selling jewelry and apparel including furniture stores plus eateries.",
      "poi_long_description": "People say this shopping center offers a wide selection of stores, restaurants, and a grocery store, as well as a playground. They highlight the fun, walkable, and safe outdoor mall with beautiful landscaping and a spacious layout. They also like the convenient parking and the dog-friendly atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-edab-72cb-91e4-e04d1451c589.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-edab-72cb-91e4-e04d1451c589",
        "storage_key": "property/6767906449164267/019d0813-edab-72cb-91e4-e04d1451c589.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://uvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185780485491805676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-village",
      "poi_latitude": "47.6616885",
      "poi_longitude": "-122.2990339",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-523-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c54-732a-9b12-5b3b3797517b",
        "storage_key": "property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2_IcB4YUkFQR7E2AoSzhFjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8098a99b-fe87-49d9-b9ca-0b47b782d88d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2210 Westlake Ave N, Seattle, WA 98121, USA",
      "poi_short_description": "Grocery store featuring organic produce, pastries, wine, cheese and prepared foods.",
      "poi_long_description": "People say this grocery store offers a wide variety of organic foods, fresh produce, and delicious baked goods. They also highlight the spacious layout, convenient location, and friendly staff.\n\nOther reviews mention the hot bar can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-f001-72c8-bad6-4a1a3c24544f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-f001-72c8-bad6-4a1a3c24544f",
        "storage_key": "property/6767906449164267/019d0813-f001-72c8-bad6-4a1a3c24544f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/westlake?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13331991485400734650&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.6183573",
      "poi_longitude": "-122.3380162",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-621-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c5e-7151-8b23-d7f929b39d22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c5e-7151-8b23-d7f929b39d22",
        "storage_key": "property/6767906449164267/019d0814-3c5e-7151-8b23-d7f929b39d22.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyz9g9EkVkFQRutvXu56_BLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_99f0d277-04c8-4231-bc53-7630b461ff3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Uwajimaya Seattle",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 5th Ave S, Seattle, WA 98104, USA",
      "poi_short_description": "Supermarket offering a wide selection of Asian items, plus a bakery, deli and food court.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh seafood, produce, snacks, and Japanese food, including sushi and poke. They highlight the reasonable portions, fair prices, and the fun, clean, and well-organized atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-f002-7193-8dff-57563b73fdb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-f002-7193-8dff-57563b73fdb7",
        "storage_key": "property/6767906449164267/019d0813-f002-7193-8dff-57563b73fdb7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/seattle/?utm_source=localprofiles&utm_medium=organic&utm_content=seattle&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=18369564176154316475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-seattle",
      "poi_latitude": "47.5967467",
      "poi_longitude": "-122.3270506",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-624-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c5e-7151-8b23-d7f929b39d22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c5e-7151-8b23-d7f929b39d22",
        "storage_key": "property/6767906449164267/019d0814-3c5e-7151-8b23-d7f929b39d22.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq9nX27xqkFQRu05rxkrN7f4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_d1228966-1263-4961-abad-9a6ea1e59f1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Northgate Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "401 NE Northgate Way, Seattle, WA 98125, USA",
      "poi_short_description": "Shopping center with a variety of stores, restaurants, and a playground.",
      "poi_long_description": "People say this shopping center offers a variety of stores and is conveniently located near a light rail station, movie theaters, and a sports facility. They also highlight the clean, well-lit, and accessible station with ample parking and easy access to public transportation.\n\nOther reviews mention the construction can be ongoing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-f409-733f-ba8f-4171aa4adbac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-f409-733f-ba8f-4171aa4adbac",
        "storage_key": "property/6767906449164267/019d0813-f409-733f-ba8f-4171aa4adbac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/northgate-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=7968531460125271769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northgate-station",
      "poi_latitude": "47.70612269999999",
      "poi_longitude": "-122.3258649",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-362-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c54-732a-9b12-5b3b3797517b",
        "storage_key": "property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn7o7cFYRkFQR2aZK1iTplW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6d2ce766-2c26-4918-bba1-92ab446ceb4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1700 E Madison St, Seattle, WA 98122, USA",
      "poi_short_description": "Grocery store selling a variety of staples, snacks, prepared foods, and produce under its own brand name.",
      "poi_long_description": "People say this grocery store offers a wide variety of products, including unique and rare items, and fresh produce. They highlight the reasonable prices, especially for organic options, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-f3fe-72ae-84bb-e3983102c968.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-f3fe-72ae-84bb-e3983102c968",
        "storage_key": "property/6767906449164267/019d0813-f3fe-72ae-84bb-e3983102c968.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/seattle/130/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5748370317872008118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.61582569999999",
      "poi_longitude": "-122.309937",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-322-7268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c5e-7151-8b23-d7f929b39d22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c5e-7151-8b23-d7f929b39d22",
        "storage_key": "property/6767906449164267/019d0814-3c5e-7151-8b23-d7f929b39d22.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0M1ztNqkFQRtgspEllQxk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ee52982e-a3ea-4c67-82bf-e5696ef51f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Seattle Public Library - Central Library",
      "poi_type": "Education",
      "poi_address": "1000 4th Ave, Seattle, WA 98104, USA",
      "poi_short_description": "Striking design for a vast chain library with a reading room, computer lab and a book spiral.",
      "poi_long_description": "People say this public library offers a vast collection of books, digital media, and archives, as well as computers and study spaces. They highlight the modern architecture, spacious layout, and quiet atmosphere, making it a comfortable place to read and work. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-f611-7317-9ec7-11bdc4418fa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-f611-7317-9ec7-11bdc4418fa7",
        "storage_key": "property/6767906449164267/019d0813-f611-7317-9ec7-11bdc4418fa7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.spl.org/hours-and-locations/central-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=12943420815159197138&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-public-library---central-library",
      "poi_latitude": "47.6066621",
      "poi_longitude": "-122.3321837",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-386-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ55fLWVtBkFQR0v31eadEoLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_846654fd-0a96-44a0-b6f5-2682d92029da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "University of Washington",
      "poi_type": "Education",
      "poi_address": "1410 NE Campus Pkwy, Seattle, WA 98195, USA",
      "poi_short_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_long_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-f63b-741f-992d-069de120b904.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-f63b-741f-992d-069de120b904",
        "storage_key": "property/6767906449164267/019d0813-f63b-741f-992d-069de120b904.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.washington.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742862557588237219&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington",
      "poi_latitude": "47.65671709999999",
      "poi_longitude": "-122.3066181",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-543-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zWFnZIUkFQRoyu4AXksdGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dd0280b8-f3c0-4a7c-bb1a-ee3fd7a079d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Seattle Central College",
      "poi_type": "Education",
      "poi_address": "1701 Broadway, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-fbf5-7172-be4b-57c1b214b65b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-fbf5-7172-be4b-57c1b214b65b",
        "storage_key": "property/6767906449164267/019d0813-fbf5-7172-be4b-57c1b214b65b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://seattlecentral.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860090414231206236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-central-college",
      "poi_latitude": "47.6167229",
      "poi_longitude": "-122.3215965",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-934-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJScFRw8xqkFQRXDnUjTNcGtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d94f626d-7a5c-44b9-8971-4814cdc5d95d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Seattle University",
      "poi_type": "Education",
      "poi_address": "901 12th Ave, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-fbe2-762a-a51d-50098fced391.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-fbe2-762a-a51d-50098fced391",
        "storage_key": "property/6767906449164267/019d0813-fbe2-762a-a51d-50098fced391.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seattleu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887710188514951233&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-university",
      "poi_latitude": "47.6091765",
      "poi_longitude": "-122.3178465",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-296-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZv0y8hqkFQRQcB9L4Wi1EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_43cbac5b-821b-4490-adfa-18841ccf3ece",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "North Seattle College",
      "poi_type": "Education",
      "poi_address": "9600 College Way N, Seattle, WA 98103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-fe84-74a2-a8a1-8685311aed1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-fe84-74a2-a8a1-8685311aed1c",
        "storage_key": "property/6767906449164267/019d0813-fe84-74a2-a8a1-8685311aed1c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://northseattle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=404283079753513623&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-seattle-college",
      "poi_latitude": "47.6989479",
      "poi_longitude": "-122.3326717",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-934-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVWVdQEUkFQRl7porVFNnAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3691e965-afa2-4c23-bb0b-328bbc294753",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "T-Mobile Park",
      "poi_type": "Entertainment",
      "poi_address": "1250 1st Ave S, Seattle, WA 98134, USA",
      "poi_short_description": "Seattle Mariners' ballpark with city skyline views, lots of stadium eats & a retractable roof.",
      "poi_long_description": "People say this stadium offers exciting baseball games, concerts, and fireworks shows, with a retractable roof and views of the city skyline. They highlight the electric atmosphere, family-friendly vibe, and convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-feca-7002-b415-c9b65e1b66c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-feca-7002-b415-c9b65e1b66c3",
        "storage_key": "property/6767906449164267/019d0813-feca-7002-b415-c9b65e1b66c3.webp",
        "width": 1242,
        "height": 540
      },
      "poi_business_url": "http://seattle.mariners.mlb.com/sea/ballpark/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14337255265305820565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "t-mobile-park",
      "poi_latitude": "47.591472",
      "poi_longitude": "-122.3325833",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-346-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41ad-70cd-9696-9fa16dc25788.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41ad-70cd-9696-9fa16dc25788",
        "storage_key": "property/6767906449164267/019d0814-41ad-70cd-9696-9fa16dc25788.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28RdUJ9qkFQRlf2mprMp-MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_51a4c0df-a1e1-40a7-a6b4-1be5629299e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Climate Pledge Arena",
      "poi_type": "Entertainment",
      "poi_address": "334 1st Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Large venue hosts WNBA & NCAA basketball, roller derby, concerts & events for up to 17,000 people.",
      "poi_long_description": "People say this arena offers a variety of food and drink options, and the acoustics are great for concerts and hockey games. They highlight the modern design, clean facilities, and comfortable seating, as well as the electric vibe during Kraken games. They also like the friendly and efficient staff, and the convenient access via the monorail. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-0486-719e-9bb8-d2d63b1aa066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-0486-719e-9bb8-d2d63b1aa066",
        "storage_key": "property/6767906449164267/019d0814-0486-719e-9bb8-d2d63b1aa066.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://climatepledgearena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15998104634649095719&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "climate-pledge-arena",
      "poi_latitude": "47.62207129999999",
      "poi_longitude": "-122.3540714",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-752-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ046-cUQVkFQRJy7KU2evBN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_51a2ac19-8702-47f8-b217-da14a66ab477",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Lumen Field",
      "poi_type": "Entertainment",
      "poi_address": "800 Occidental Ave S, Seattle, WA 98134, USA",
      "poi_short_description": "Home of the Seahawks & Sounders, this 68,740-seat multipurpose stadium features skyline views.",
      "poi_long_description": "People say this stadium offers a variety of local food, including chowder, and has great views from most seats, with some being covered. They highlight the energetic atmosphere, the clean facilities, and the easy access via light rail and bus. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-03b0-736d-98ad-217ba56d5d37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-03b0-736d-98ad-217ba56d5d37",
        "storage_key": "property/6767906449164267/019d0814-03b0-736d-98ad-217ba56d5d37.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "http://www.lumenfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11976986007816512220&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lumen-field",
      "poi_latitude": "47.5951518",
      "poi_longitude": "-122.3316394",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-381-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41ad-70cd-9696-9fa16dc25788.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41ad-70cd-9696-9fa16dc25788",
        "storage_key": "property/6767906449164267/019d0814-41ad-70cd-9696-9fa16dc25788.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKxjxuaNqkFQR3CK6O1HNNqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_cbe35a41-8aee-41d1-b288-cf32d7836963",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Woodland Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "Seattle, WA 98103, USA",
      "poi_short_description": "Variety of wildlife on display, plus a carousel, rainforest exhibit, and bug house.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including gorillas, hippos, and red pandas, and features a historic carousel and a dinosaur exhibit. They highlight the spacious enclosures, the beautiful, natural environment with lots of vegetation, and the family-friendly atmosphere. They also like the well-maintained grounds and the knowledgeable, kind staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-0696-72a9-8048-b60ba4339f8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-0696-72a9-8048-b60ba4339f8b",
        "storage_key": "property/6767906449164267/019d0814-0696-72a9-8048-b60ba4339f8b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.zoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962776519554476210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-park-zoo",
      "poi_latitude": "47.668436",
      "poi_longitude": "-122.3508786",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-548-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydSuSkkUkFQRsqhB-cEtYnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_caf125d4-7572-42c4-bd35-8f4536b0e804",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Seattle Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1483 Alaskan Way Pier 59, Seattle, WA 98101, USA",
      "poi_short_description": "Modern venue with sharks, seals, octopuses and otters, plus jellyfish, tide pools and touch tanks.",
      "poi_long_description": "People say this aquarium offers a variety of marine life, including sea otters, seals, and an octopus, as well as interactive touch pools and a new Ocean Pavilion. They also highlight the friendly and knowledgeable staff, and the clean and informative exhibits.\n\nOther reviews mention the admission can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-06c1-771a-b10b-3d454983f484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-06c1-771a-b10b-3d454983f484",
        "storage_key": "property/6767906449164267/019d0814-06c1-771a-b10b-3d454983f484.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://www.seattleaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7753481524406941315&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-aquarium",
      "poi_latitude": "47.6074002",
      "poi_longitude": "-122.3429559",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-386-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ_oEiK1qkFQRg3bU4l3mmWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_0e52593c-66e2-46b7-a1cf-51960b1621a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1416 NW Ballard Way, Seattle, WA 98107, USA",
      "poi_short_description": "Sporting gym with cardio equipment, free weights and an indoor pool (open year-round), plus a sauna.",
      "poi_long_description": "People say this gym offers a variety of equipment, a pool, and training sessions, and the staff is friendly and helpful.\n\nOther reviews mention the equipment can be broken and the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-0a9e-7164-b331-cacf27d19ae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-0a9e-7164-b331-cacf27d19ae2",
        "storage_key": "property/6767906449164267/019d0814-0a9e-7164-b331-cacf27d19ae2.webp",
        "width": 1280,
        "height": 1121
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=455&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3768693322368076231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.662302",
      "poi_longitude": "-122.3755124",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-508-5030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpfJWZLcVkFQRx8ki-5sWTTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d9ee92d4-2a44-44d5-81ba-b61a084c326d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1827 Yale Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Chain featuring squat racks, treadmills, weights, machines and locker rooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-0cbd-72d0-943a-7c22915f92ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-0cbd-72d0-943a-7c22915f92ee",
        "storage_key": "property/6767906449164267/019d0814-0cbd-72d0-943a-7c22915f92ee.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/seattle-wa/downtown-seattle-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=3594284804022718634&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.6180661",
      "poi_longitude": "-122.330962",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-624-0651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu5csWjQVkFQRqtBbZfx24TE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2258b921-9194-4bc2-b5c5-caf3bfd04ff4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Olympic Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "5301 Leary Ave NW, Seattle, WA 98107, USA",
      "poi_short_description": "Membership-based health club offering classes and modern equipment.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and amenities, including a pool, sauna, steam room, and hot tub. They also highlight the spacious layout, modern facilities, and convenient parking.\n\nOther reviews mention the sauna can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-0e43-707d-9a46-e318a964e096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-0e43-707d-9a46-e318a964e096",
        "storage_key": "property/6767906449164267/019d0814-0e43-707d-9a46-e318a964e096.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://www.olympicathleticclub.com/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9243484350012506487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olympic-athletic-club",
      "poi_latitude": "47.6664152",
      "poi_longitude": "-122.3828324",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-944-3615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-6exLYVkFQRd8Fg0Qp0R4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cb6ba09b-48e8-4c13-bf71-ba187d5dce43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 NW Market St #100, Seattle, WA 98107, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers good quality and well-functioning equipment, and the facilities are clean.\n\nOther reviews mention the temperature can be hot and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-1518-764b-becf-340bcdbfd024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-1518-764b-becf-340bcdbfd024",
        "storage_key": "property/6767906449164267/019d0814-1518-764b-becf-340bcdbfd024.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18000937299387102910&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.668813",
      "poi_longitude": "-122.3773675",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-260-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1WjAVG8VkFQRvjYMyhkt0Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_c75bf775-6017-4ade-9ac6-002194dbfd90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Equinox Rainier Square",
      "poi_type": "Health and Wellness",
      "poi_address": "401 Union St Suite 220, Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of group classes and top-of-the-line equipment, and the staff is friendly and professional.\n\nOther reviews mention the weightlifting equipment can be limited and the parking can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-127f-7733-ab65-8ac8058e7784.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-127f-7733-ab65-8ac8058e7784",
        "storage_key": "property/6767906449164267/019d0814-127f-7733-ab65-8ac8058e7784.webp",
        "width": 265,
        "height": 265
      },
      "poi_business_url": "https://equinox-spa.com/serviceGroupDetails?facilityId=790&cid=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3460855741733625954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "equinox-rainier-square",
      "poi_latitude": "47.6092692",
      "poi_longitude": "-122.335354",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-336-0260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5aexv1rkFQRYmDn8PVtBzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5ac57ee3-31af-4589-9c07-792b8860177b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Barry's Seattle",
      "poi_type": "Health and Wellness",
      "poi_address": "112 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Chains for group training in the Red Room on treadmills, interspersed with bench exercises.",
      "poi_long_description": "People say this fitness center offers a challenging workout that combines cardio, strength, weights, resistance, stretching, and agility. They highlight the fun music, high energy, and positive vibe. They also like the motivational and encouraging instructors. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-1691-76ed-a3fe-37fbd9c8991f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-1691-76ed-a3fe-37fbd9c8991f",
        "storage_key": "property/6767906449164267/019d0814-1691-76ed-a3fe-37fbd9c8991f.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.barrys.com/studio/seattle",
      "poi_directions_map_url": "https://maps.google.com/?cid=1874324567168923080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barrys-seattle",
      "poi_latitude": "47.6188612",
      "poi_longitude": "-122.3382048",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-687-7180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq8epeK8VkFQRyDXkY0PwAho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_fb92ef02-62ce-4009-8d01-d3cd85515d5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "West Seattle Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2629 SW Andover St, Seattle, WA 98126, USA",
      "poi_short_description": "Swimming, spacious gym featuring a rock-climbing wall and a heated pool.",
      "poi_long_description": "People say this fitness center offers a wide variety of amenities, including a pool, sauna, and jacuzzi, as well as numerous classes and workout equipment. They also highlight the friendly and helpful staff, and the clean and comfortable facilities.\n\nSome reviews mention the machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-1871-779c-afa0-80648ff5f94b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-1871-779c-afa0-80648ff5f94b",
        "storage_key": "property/6767906449164267/019d0814-1871-779c-afa0-80648ff5f94b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://westseattlehc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17611443290596558280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-seattle-health-club",
      "poi_latitude": "47.5680479",
      "poi_longitude": "-122.3676256",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-556-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizEFLE7YB0ERyMXxBV1qaPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d1361d3d-8ac4-4e94-b11f-b9d1251c0d8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "[solidcore] SLU",
      "poi_type": "Health and Wellness",
      "poi_address": "2139 6th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-1889-7508-9135-e885d0b5705e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-1889-7508-9135-e885d0b5705e",
        "storage_key": "property/6767906449164267/019d0814-1889-7508-9135-e885d0b5705e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.solidcore.co/wa/seattle/slu/?utm_source=google&utm_medium=search&utm_content=local-listing&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12001859543961006521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "solidcore-slu",
      "poi_latitude": "47.6153071",
      "poi_longitude": "-122.3404108",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-594-3782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4Vi9xnMVkFQRuXHtqaorj6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b9a24c47-5af4-47c5-8c05-a794219304f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Seattle Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Sand Point Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-1bbd-7734-9848-648fb02152ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-1bbd-7734-9848-648fb02152ed",
        "storage_key": "property/6767906449164267/019d0814-1bbd-7734-9848-648fb02152ed.webp",
        "width": 920,
        "height": 612
      },
      "poi_business_url": "https://www.seattlechildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535247879101277020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-childrens-hospital",
      "poi_latitude": "47.6628364",
      "poi_longitude": "-122.281996",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-987-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41e4-749d-b0bd-7f332a39dc7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41e4-749d-b0bd-7f332a39dc7c",
        "storage_key": "property/6767906449164267/019d0814-41e4-749d-b0bd-7f332a39dc7c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYx10YIUkFQRXOPoZdRuFaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_97f261c8-85a5-4b85-8e29-bee45218711b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Harborview Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "325 9th Ave Main Hospital, Seattle, WA 98104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-1d9a-709a-a826-dd951949ad32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-1d9a-709a-a826-dd951949ad32",
        "storage_key": "property/6767906449164267/019d0814-1d9a-709a-a826-dd951949ad32.webp",
        "width": 1279,
        "height": 903
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/harborview-medical-center?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6803544737971406536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harborview-medical-center",
      "poi_latitude": "47.6039167",
      "poi_longitude": "-122.323905",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-744-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41e4-749d-b0bd-7f332a39dc7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41e4-749d-b0bd-7f332a39dc7c",
        "storage_key": "property/6767906449164267/019d0814-41e4-749d-b0bd-7f332a39dc7c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7w3EijcVkFQRyIZDeOQLa14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4ac6d829-eeac-4330-8c67-1e429bccea30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Gas Works Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 N Northlake Way, Seattle, WA 98103, USA",
      "poi_short_description": "Grass-covered urban park sporting views of Seattle (especially at night) as well as Lake Union.",
      "poi_long_description": "People say this city park offers stunning views of the Seattle skyline, Lake Union, and the Space Needle, and is a great spot for picnics, kite flying, and watching seaplanes. They highlight the spacious grounds, walking paths, and the unique, industrial charm of the preserved gas plant structures. They also like the fun vibe, especially during summer events with music, yoga, and free DJ sets. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-1f52-74a7-a857-24d48535bab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-1f52-74a7-a857-24d48535bab5",
        "storage_key": "property/6767906449164267/019d0814-1f52-74a7-a857-24d48535bab5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/gas-works-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2192784265468010902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gas-works-park",
      "poi_latitude": "47.6456308",
      "poi_longitude": "-122.3343532",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41e2-708d-8faa-038b95ee0484",
        "storage_key": "property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7BbsgIVkFQRlmFJ7KtVbh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c3243cf6-bbf6-480f-a057-1893c9bd9844",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Kerry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "211 W Highland Dr, Seattle, WA 98119, USA",
      "poi_short_description": "Small park atop a hill with a famed view of Seattle's skyline, plus picnic benches.",
      "poi_long_description": "People say this city park offers stunning panoramic views of the Seattle skyline, Space Needle, and Mount Rainier, especially at sunset. They highlight the relaxing and chill vibe, and the perfect photo opportunities for capturing postcard-worthy views. They also like the easy access and free admission.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-1fc7-761e-8c44-ff9c7e3e31d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-1fc7-761e-8c44-ff9c7e3e31d9",
        "storage_key": "property/6767906449164267/019d0814-1fc7-761e-8c44-ff9c7e3e31d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattle.gov/parks/find/parks/kerry-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3744576093846549902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kerry-park",
      "poi_latitude": "47.6294692",
      "poi_longitude": "-122.3599224",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41e2-708d-8faa-038b95ee0484",
        "storage_key": "property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUS2ELmoVkFQRjrUkJB5o9zM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c472ce30-ab23-4416-bb79-4e249eed81d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Golden Gardens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8498 Seaview Pl NW, Seattle, WA 98117, USA",
      "poi_short_description": "Popular seaside park featuring fire pits, barbecues and a sandy beach.",
      "poi_long_description": "People say this city park offers a sandy beach, volleyball courts, fire pits, and picnic areas with BBQ grills. They highlight the stunning views of the Puget Sound and Olympic Mountains, and the relaxing vibe perfect for watching sunsets. They also like the ample free parking and the dog-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-2152-7162-85b7-0b972cad2adc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-2152-7162-85b7-0b972cad2adc",
        "storage_key": "property/6767906449164267/019d0814-2152-7162-85b7-0b972cad2adc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/golden-gardens-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6569770599323732682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-gardens-park",
      "poi_latitude": "47.6917517",
      "poi_longitude": "-122.4030912",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41e2-708d-8faa-038b95ee0484",
        "storage_key": "property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72JgjmQWkFQRygp_TI2DLFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2d04d510-aaeb-4cbf-8731-3f25591c6c4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Seattle, WA 98199, USA",
      "poi_short_description": "Park offering trails, picnic facilities, and a lighthouse, plus scenic views.",
      "poi_long_description": "People say this park offers gorgeous trails, a lighthouse, and a beach, with stunning views of the Puget Sound, Olympic Mountains, and Mount Rainier. They highlight the peaceful and serene vibe, and the variety of terrain and ecosystems, including forests, plains, bluffs, and beaches. They also like the dog-friendly trails and the opportunity for picnics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-24a7-77c7-a577-598e029faa33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-24a7-77c7-a577-598e029faa33",
        "storage_key": "property/6767906449164267/019d0814-24a7-77c7-a577-598e029faa33.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/discovery-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5879522751650882336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "47.6613197",
      "poi_longitude": "-122.4171413",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41e2-708d-8faa-038b95ee0484",
        "storage_key": "property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn0CO4fAVkFQRIGP6pMpCmFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_967beaf7-0cc8-4208-a6c1-04d18ccb803c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Olympic Sculpture Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2901 Western Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Artful destination with a waterfront walking trail, showcasing sculptures and more.",
      "poi_long_description": "Visitors say this park offers a peaceful waterfront setting with stunning views of the Space Needle, Elliott Bay, and sculptures. They also highlight the dog-friendly atmosphere, walking trails, and benches perfect for picnics or relaxing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-274b-73e9-90bd-408da9ec410a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-274b-73e9-90bd-408da9ec410a",
        "storage_key": "property/6767906449164267/019d0814-274b-73e9-90bd-408da9ec410a.webp",
        "width": 1080,
        "height": 791
      },
      "poi_business_url": "https://www.seattleartmuseum.org/visit/olympic-sculpture-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8934295156938678169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olympic-sculpture-park",
      "poi_latitude": "47.6166028",
      "poi_longitude": "-122.3553167",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-654-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41e2-708d-8faa-038b95ee0484",
        "storage_key": "property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc88dJ1AVkFQRmZ_S-xv-_Hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0b5ae2e4-0d25-46c3-b591-7cb9913d6a21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Westlake",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-28eb-726b-8707-5f6dc6a28efe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-28eb-726b-8707-5f6dc6a28efe",
        "storage_key": "property/6767906449164267/019d0814-28eb-726b-8707-5f6dc6a28efe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5693109731314450214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westlake",
      "poi_latitude": "47.61157",
      "poi_longitude": "-122.33672",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQyrwLRqkFQRJj9RIiP9AU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_31cf0587-8526-4444-907e-c8cd4929f250",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "U District",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this light rail station is clean and spacious. They highlight the ample security and modern design. They also like the changing art installations. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-2961-7081-8aac-138b977e53d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-2961-7081-8aac-138b977e53d8",
        "storage_key": "property/6767906449164267/019d0814-2961-7081-8aac-138b977e53d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/u-district-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=8874690119994055692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "u-district",
      "poi_latitude": "47.6599885",
      "poi_longitude": "-122.3140745",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93n1LIsUkFQRDBzq3aQ7KXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_268aa6c8-0450-4519-b9e2-fe655b5d9ced",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "University of Washington Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-2b36-7035-be3c-3f44245a6630.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-2b36-7035-be3c-3f44245a6630",
        "storage_key": "property/6767906449164267/019d0814-2b36-7035-be3c-3f44245a6630.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/university-washington-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=18042961121833481987&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-station",
      "poi_latitude": "47.65031",
      "poi_longitude": "-122.30374",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdBrZusUkFQRA3cRa4t5Zfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_da6268f3-f2b1-484d-bc79-a9d3867e6a1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Symphony",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-2dc4-7338-8a66-e49f6ce102b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-2dc4-7338-8a66-e49f6ce102b4",
        "storage_key": "property/6767906449164267/019d0814-2dc4-7338-8a66-e49f6ce102b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10052292521089458792&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "symphony",
      "poi_latitude": "47.60781",
      "poi_longitude": "-122.33602",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRf6wbNqkFQRaGLa4cnqgIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_f8e068bd-1c9e-4c63-b900-bee17c69f218",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "King County International Airport - Boeing Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7277 Perimeter Rd S, Seattle, WA 98108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-31d4-72b0-ab60-a4fd39536ea6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-31d4-72b0-ab60-a4fd39536ea6",
        "storage_key": "property/6767906449164267/019d0814-31d4-72b0-ab60-a4fd39536ea6.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "http://www.kingcounty.gov/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635828346216693482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "king-county-international-airport---boeing-field",
      "poi_latitude": "47.5369043",
      "poi_longitude": "-122.3038555",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-296-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-461f-70ae-9f4a-65a984c23652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-461f-70ae-9f4a-65a984c23652",
        "storage_key": "property/6767906449164267/019d0814-461f-70ae-9f4a-65a984c23652.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_--ofVBkFQR6r7ut1HFVUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_35c7c4f0-accb-42a9-bc0b-a534052a4430",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Amazon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2111 7th Ave, Seattle, WA 98121",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-c0fd-712d-b1fb-f65ce77ea95e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c0fd-712d-b1fb-f65ce77ea95e",
        "storage_key": "property/6767906449164267/019dbbe6-c0fd-712d-b1fb-f65ce77ea95e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10321563756011321016&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amazon",
      "poi_latitude": "47.622455300000006",
      "poi_longitude": "-122.33947429999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 866-495-8564",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8aGizcVkFQRuPaZ04yPPY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_30192423-d890-472d-b753-3e380ec39a44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Google Park View",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 N 34th St, Seattle, WA 98103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-bf78-73fd-8dc7-61d0df4d2e6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-bf78-73fd-8dc7-61d0df4d2e6f",
        "storage_key": "property/6767906449164267/019dbbe6-bf78-73fd-8dc7-61d0df4d2e6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://google.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8743574520790048170&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "google-park-view",
      "poi_latitude": "47.648994",
      "poi_longitude": "-122.3503845",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-876-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8Lh5AYVkFQRqt3YgrNqV3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b763334d-6837-4a1e-b435-514ba380b050",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Meta",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1101 Dexter Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-c0e3-745c-8ada-0de589c28e86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c0e3-745c-8ada-0de589c28e86",
        "storage_key": "property/6767906449164267/019dbbe6-c0e3-745c-8ada-0de589c28e86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.meta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=498136285511713012&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "meta",
      "poi_latitude": "47.6292488",
      "poi_longitude": "-122.3425299",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 650-543-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJidZEkT4VkFQR9ICo-0-86QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_745ab1e8-7514-49c6-86f3-fcf76f56e694",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Apple",
      "poi_type": "Major Employers & Offices",
      "poi_address": "333 Dexter Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-bf37-7587-abc2-31e6d5778a5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-bf37-7587-abc2-31e6d5778a5b",
        "storage_key": "property/6767906449164267/019dbbe6-bf37-7587-abc2-31e6d5778a5b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://apple.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13819581059121944037&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "apple",
      "poi_latitude": "47.62159459999999",
      "poi_longitude": "-122.3429722",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-607-1738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49E1x4gVkFQR5RWuBcEDyb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4abeb9c2-025f-4d72-9a7e-5f7ed6c0b827",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Axon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1100 Olive Wy #1300, Seattle, WA 98101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-ca34-740c-8385-e068c4ed5c99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-ca34-740c-8385-e068c4ed5c99",
        "storage_key": "property/6767906449164267/019dbbe6-ca34-740c-8385-e068c4ed5c99.webp",
        "width": 721,
        "height": 480
      },
      "poi_business_url": "https://www.axon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8596825010649489386&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "axon",
      "poi_latitude": "47.6163177",
      "poi_longitude": "-122.3304138",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 800-978-2737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQBAGTUVkFQR6t_0m8wOTnc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3338375b-c0b4-4ae7-a0b5-f5afd07526c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Grecian Corner",
      "poi_type": "Restaurants",
      "poi_address": "100 4th Ave N #160, Seattle, WA 98109, USA",
      "poi_short_description": "Laid-back outpost offering Greek fare such as grilled kebabs, gyros & falafels plus beer & wine.",
      "poi_long_description": "Laid-back outpost offering Greek fare such as grilled kebabs, gyros & falafels plus beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-cad8-71b1-9440-7c228d81cf7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-cad8-71b1-9440-7c228d81cf7a",
        "storage_key": "property/6767906449164267/019dbbe6-cad8-71b1-9440-7c228d81cf7a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://order.online/store/25113343?slug=grecian-corner-11652737&pickup=true&hideModal=true",
      "poi_directions_map_url": "https://maps.google.com/?cid=15507111278196969136&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "grecian-corner",
      "poi_latitude": "47.6192265",
      "poi_longitude": "-122.3487087",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-572-2930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c5f-755e-94f4-05f7f7096686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c5f-755e-94f4-05f7f7096686",
        "storage_key": "property/6767906449164267/019d0814-3c5f-755e-94f4-05f7f7096686.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaEmV08VkFQRsE5iHYxTNNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_60d73aa5-c1c0-419b-9247-21b6f6679edc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Karaage Setsuna",
      "poi_type": "Restaurants",
      "poi_address": "2429 2nd Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Unassuming option for Japanese/Hawaiian fusion dishes, with signature Japanese-style fried chicken.",
      "poi_long_description": "People say this restaurant serves delicious karaage, ramen, curry, and poke bowls. They highlight the generous portions and fair prices. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-cc95-75d2-9ff9-845fdac49c34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-cc95-75d2-9ff9-845fdac49c34",
        "storage_key": "property/6767906449164267/019dbbe6-cc95-75d2-9ff9-845fdac49c34.webp",
        "width": 719,
        "height": 1280
      },
      "poi_business_url": "http://karaagesetsuna.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242791768245341715&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "karaage-setsuna",
      "poi_latitude": "47.6151835",
      "poi_longitude": "-122.3478917",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-448-3595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c5f-755e-94f4-05f7f7096686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c5f-755e-94f4-05f7f7096686",
        "storage_key": "property/6767906449164267/019d0814-3c5f-755e-94f4-05f7f7096686.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZKYe04VkFQREw6b8VUjwkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_af3dbc2c-6c8b-493d-8796-d13e8a824025",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Artisan Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2523 5th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Snug coffee shop provides an array of espresso drinks & varied daytime fare in a contemporary space.",
      "poi_long_description": "People say this cafe serves delicious sandwiches, croissants, and Vietnamese baguettes. They highlight the fresh food, good coffee, and reasonable prices. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-cc1b-749d-9030-d054bea2bccb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-cc1b-749d-9030-d054bea2bccb",
        "storage_key": "property/6767906449164267/019dbbe6-cc1b-749d-9030-d054bea2bccb.webp",
        "width": 1280,
        "height": 1237
      },
      "poi_business_url": "http://www.artisancafeonvine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6080598537031153811&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "artisan-cafe",
      "poi_latitude": "47.6176695",
      "poi_longitude": "-122.3463233",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-441-8885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe7-0943-73d6-80e0-7bffdcdbee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe7-0943-73d6-80e0-7bffdcdbee93",
        "storage_key": "property/6767906449164267/019dbbe7-0943-73d6-80e0-7bffdcdbee93.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJteL-1U4VkFQRk3iALSegYlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_d0e26e52-efd7-427a-851d-fe18546554f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "The 5 Point Cafe",
      "poi_type": "Restaurants",
      "poi_address": "415 Cedar St, Seattle, WA 98121, USA",
      "poi_short_description": "Circa-1929 American diner open 24/7 serving hearty all-day breakfasts, burgers & hot sandwiches.",
      "poi_long_description": "Diners say this diner serves up delicious chicken fried steak, burgers, and cheese curds, with many raving about the chicken fried steak and its generous portions. They also highlight the friendly and attentive service, lively atmosphere, and 24-hour availability.\n\nSome reviews mention the interior can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-d0c7-72d7-921f-417a19b3ef56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d0c7-72d7-921f-417a19b3ef56",
        "storage_key": "property/6767906449164267/019dbbe6-d0c7-72d7-921f-417a19b3ef56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.the5pointcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16471903945836826826&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-5-point-cafe",
      "poi_latitude": "47.6180712",
      "poi_longitude": "-122.3473786",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-448-9991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c5f-755e-94f4-05f7f7096686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c5f-755e-94f4-05f7f7096686",
        "storage_key": "property/6767906449164267/019d0814-3c5f-755e-94f4-05f7f7096686.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibX4ME8VkFQRypD16V31l-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_494d55bd-4cf0-498a-8ee7-0bfccbb71fe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Carmine's - 5th Avenue",
      "poi_type": "Restaurants",
      "poi_address": "1420 5th Ave, Seattle, WA 98101, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this Italian restaurant serves delicious pasta, veal, and tomato soup. They highlight the beautiful and elegant atmosphere, and the attentive and welcoming service. They also like the fun vibe, making it a great spot for a date night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-e255-714b-97c6-7a3eda525d42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e255-714b-97c6-7a3eda525d42",
        "storage_key": "property/6767906449164267/019dbbe6-e255-714b-97c6-7a3eda525d42.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://carminesonfifth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7958715870100971798&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carmines---5th-avenue",
      "poi_latitude": "47.6106057",
      "poi_longitude": "-122.3341309",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-506-0886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c5f-755e-94f4-05f7f7096686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c5f-755e-94f4-05f7f7096686",
        "storage_key": "property/6767906449164267/019d0814-3c5f-755e-94f4-05f7f7096686.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxnjaXZrkFQRFuGhseoJc24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_87846974-c29e-422c-87af-2c43e63d90be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Westlake Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "400 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "4-story, glass-enclosed retail center for shopping & dining with a food court.",
      "poi_long_description": "Visitors say this shopping center is clean and conveniently located near major attractions like Pike Place Market, with easy access to the Seattle Monorail and light rail. They also highlight the diverse dining options, including a food court with local choices, and a mix of stores, from well-known brands to smaller boutiques.\n\nSome reviews mention the mall can be dated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-d3e1-77fe-939b-fc76f4cfb282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d3e1-77fe-939b-fc76f4cfb282",
        "storage_key": "property/6767906449164267/019dbbe6-d3e1-77fe-939b-fc76f4cfb282.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.westlakecenter.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=878541090116204128&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "westlake-center",
      "poi_latitude": "47.6120485",
      "poi_longitude": "-122.33743249999999",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-467-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c54-732a-9b12-5b3b3797517b",
        "storage_key": "property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5YbCpbRqkFQRYPb1fHc0MQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_adfa5c52-1bec-4dae-8e21-e162d5e017d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Pacific Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Downtown plaza with upscale & midscale stores, a few restaurants & a movie multiplex.",
      "poi_long_description": "People say this shopping center offers a convenient location for catching a movie at the AMC theater, dining at various restaurants, and browsing unique shops. They also highlight the cool architecture, natural lighting, and proximity to public transportation.\n\nSome reviews mention the number of shops can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-d57e-778f-80f7-7bdde33afcc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d57e-778f-80f7-7bdde33afcc8",
        "storage_key": "property/6767906449164267/019dbbe6-d57e-778f-80f7-7bdde33afcc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pacificplaceseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6358847724559966881&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pacific-place",
      "poi_latitude": "47.613372",
      "poi_longitude": "-122.33525909999997",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-652-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c54-732a-9b12-5b3b3797517b",
        "storage_key": "property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBVEQxbRqkFQRoaIym1AqP1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_02f68d2b-23f4-471f-a78a-57c975adbf66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Pike Place Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "85 Pike St, Seattle, WA 98101, USA",
      "poi_short_description": "Landmark daily market with famed fish-throwing seafood vendors, produce stalls & other shops.",
      "poi_long_description": "People say this market offers a wide variety of fresh seafood, produce, flowers, and handmade crafts. They highlight the lively atmosphere, the fun of watching the fishmongers throw fish, and the unique shopping experience. They also like the friendly vendors and staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-d7b2-71d8-a12f-0bd5569ed90f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d7b2-71d8-a12f-0bd5569ed90f",
        "storage_key": "property/6767906449164267/019dbbe6-d7b2-71d8-a12f-0bd5569ed90f.webp",
        "width": 1280,
        "height": 983
      },
      "poi_business_url": "https://www.pikeplacemarket.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660459035763804716&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pike-place-market",
      "poi_latitude": "47.6094076",
      "poi_longitude": "-122.34183580000001",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-682-7453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c54-732a-9b12-5b3b3797517b",
        "storage_key": "property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPcr187JrkFQRLApO8QKP8ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_80a3fb8e-4426-436a-b948-3a9ec63f7061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Bon Voyage Vintage",
      "poi_type": "Shopping & Retail",
      "poi_address": "110 S Washington St, Seattle, WA 98104, USA",
      "poi_short_description": "Relaxed, brightly decorated shop offering a curated selection of vintage clothing (1950s-1990s) and accessories.",
      "poi_long_description": "People say this vintage clothing store offers a wide selection of unique and stylish pieces, including jackets, t-shirts, and accessories. They highlight the reasonable prices and fun, quirky vibe. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-db76-77b6-9520-1bc5befc48b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-db76-77b6-9520-1bc5befc48b5",
        "storage_key": "property/6767906449164267/019dbbe6-db76-77b6-9520-1bc5befc48b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bonvoyagevintage.myshopify.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16373617142758275149&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bon-voyage-vintage",
      "poi_latitude": "47.6009843",
      "poi_longitude": "-122.3336941",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-226-5069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c54-732a-9b12-5b3b3797517b",
        "storage_key": "property/6767906449164267/019d0814-3c54-732a-9b12-5b3b3797517b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ34cWy7pqkFQRTXhaSgrGOuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_d6749099-59e7-4626-be5c-41283ce092b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Forget Me Not Plants & Decor",
      "poi_type": "Shopping & Retail",
      "poi_address": "807 5th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this plant nursery offers a wide selection of healthy plants, including some rare varieties, as well as planters, home decor, and books. They highlight the reasonable prices and the well-organized, lovely atmosphere. They also like the knowledgeable and helpful staff who provide plant care tips.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-decb-716f-af3e-60e910eb3c15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-decb-716f-af3e-60e910eb3c15",
        "storage_key": "property/6767906449164267/019dbbe6-decb-716f-af3e-60e910eb3c15.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://forgetmenot-seattle.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8796628253155048837&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "forget-me-not-plants--decor",
      "poi_latitude": "47.6265597",
      "poi_longitude": "-122.3477476",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-453-4467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt-tjYA4VkFQRhb14KsrmE3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "custom_e29a0b7b-1784-4a82-9ad5-78d73f909875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Dimitriou's Jazz Alley",
      "poi_type": "Entertainment",
      "poi_address": "2033 6th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Open more than 30 years, this jazz club with bi-level seating books name acts & has Northwest fare.",
      "poi_long_description": "People say this live music venue offers an intimate setting to enjoy jazz, with a menu of impressive food and drinks. They also highlight the friendly and professional staff, and the convenient free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-e00f-70ff-89aa-cb59b0214aed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e00f-70ff-89aa-cb59b0214aed",
        "storage_key": "property/6767906449164267/019dbbe6-e00f-70ff-89aa-cb59b0214aed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jazzalley.com/www-home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7484066096647445001&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dimitrious-jazz-alley",
      "poi_latitude": "47.6148157",
      "poi_longitude": "-122.339617",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-441-9729",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa2POnksVkFQRCRo3bna-3Gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_9271b3ba-9f5a-4ef5-b4dc-47372fcaada2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "SIFF Cinema Downtown",
      "poi_type": "Entertainment",
      "poi_address": "2100 4th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Cinema featuring first-run & classic films, plus concessions such as craft beer & chocolate popcorn.",
      "poi_long_description": "People say this movie theater offers a wide variety of films, including new releases and classics, and is famous for its delicious chocolate popcorn. They highlight the comfortable seats, great sound system, and large screen, as well as the reasonable prices and availability of alcohol. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-e837-716a-98ab-62f6e8c8c91e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e837-716a-98ab-62f6e8c8c91e",
        "storage_key": "property/6767906449164267/019dbbe6-e837-716a-98ab-62f6e8c8c91e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.siff.net/cinema/cinema-venues/siff-cinema-downtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=11586733313440549329&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "siff-cinema-downtown",
      "poi_latitude": "47.614043",
      "poi_longitude": "-122.3412806",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-464-5830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe7-0afc-766a-b34f-2ae27f4f8605.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe7-0afc-766a-b34f-2ae27f4f8605",
        "storage_key": "property/6767906449164267/019dbbe7-0afc-766a-b34f-2ae27f4f8605.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJGzsYf0wVkFQR0QnPNo9YzKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b5718f89-2920-493c-92d5-b9d0bb2fd177",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Pacific Science Center",
      "poi_type": "Entertainment",
      "poi_address": "200 Sue Bird Ct N, Seattle, WA 98109, USA",
      "poi_short_description": "Rotating science exhibits plus laser light shows, a tropical butterfly house & IMAX movie theaters.",
      "poi_long_description": "People say this science museum offers a variety of interactive exhibits, including a dinosaur exhibit, a butterfly house, and a maker space, as well as laser shows and planetarium shows. They highlight the educational and family-friendly atmosphere, and the reasonable parking prices. They also like the friendly and helpful staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-e7ff-734a-b5d6-2e880a008c71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e7ff-734a-b5d6-2e880a008c71",
        "storage_key": "property/6767906449164267/019dbbe6-e7ff-734a-b5d6-2e880a008c71.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pacificsciencecenter.org/?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072473183036697406&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pacific-science-center",
      "poi_latitude": "47.62004",
      "poi_longitude": "-122.3515628",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-443-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe7-0b09-71be-a8b8-d0f1c64622f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe7-0b09-71be-a8b8-d0f1c64622f8",
        "storage_key": "property/6767906449164267/019dbbe7-0b09-71be-a8b8-d0f1c64622f8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxZWvUwVkFQRPuvwC7JTqZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_df48935b-f986-49d2-9eab-d088eb8cdbc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "The Crocodile",
      "poi_type": "Entertainment",
      "poi_address": "2505 1st Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Live music venue & bar presents diverse local & national bands in a low-key, causal setting.",
      "poi_long_description": "People say this live music venue offers a variety of events, including concerts, comedy shows, and dance parties. They also highlight the great sound, intimate atmosphere, and friendly staff.\n\nOther reviews mention drinks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-eb86-727e-bafa-3d537a665351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-eb86-727e-bafa-3d537a665351",
        "storage_key": "property/6767906449164267/019dbbe6-eb86-727e-bafa-3d537a665351.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.thecrocodile.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9152732140488888689&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-crocodile",
      "poi_latitude": "47.61476769999999",
      "poi_longitude": "-122.3492781",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-420-6351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0kh2WcVkFQRcREkdmMJBX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_8321c685-08a5-4d63-a8dc-25be931b0bee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Museum of Pop Culture",
      "poi_type": "Entertainment",
      "poi_address": "325 5th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Inspired by Jimi Hendrix, the museum includes items from icons ranging from Bo Diddley to Bob Dylan.",
      "poi_long_description": "People say this art museum offers a wide variety of exhibits showcasing music, movies, and pop culture memorabilia, with interactive displays and opportunities to play instruments. They highlight the fun and engaging experience for all ages, and the informative and nostalgic atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-f233-732c-90d6-7ac88c2ad2a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f233-732c-90d6-7ac88c2ad2a8",
        "storage_key": "property/6767906449164267/019dbbe6-f233-732c-90d6-7ac88c2ad2a8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mopop.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15125666784235608082&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "museum-of-pop-culture",
      "poi_latitude": "47.6214824",
      "poi_longitude": "-122.3481245",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-770-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe7-0b09-71be-a8b8-d0f1c64622f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe7-0b09-71be-a8b8-d0f1c64622f8",
        "storage_key": "property/6767906449164267/019dbbe7-0b09-71be-a8b8-d0f1c64622f8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8p6-EYVkFQREthJEc0p6dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_feefba2d-b46c-4084-a836-02124fc55194",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Lowell Elementary School",
      "poi_type": "Education",
      "poi_address": "1058 E Mercer St, Seattle, WA 98102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-eeaf-76af-a874-f007d9f0bd1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-eeaf-76af-a874-f007d9f0bd1d",
        "storage_key": "property/6767906449164267/019dbbe6-eeaf-76af-a874-f007d9f0bd1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lowelles.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7684766049611696728&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowell-elementary-school",
      "poi_latitude": "47.62483630000001",
      "poi_longitude": "-122.3182546",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-252-3020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeyn8pC4VkFQRWEoWqQHGpWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_de53eefd-a37e-476b-a78d-7d588bf619c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Edmond S Meany Middle School",
      "poi_type": "Education",
      "poi_address": "301 21st Ave E, Seattle, WA 98112, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-ef39-7307-9a98-6b0031fcf01c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-ef39-7307-9a98-6b0031fcf01c",
        "storage_key": "property/6767906449164267/019dbbe6-ef39-7307-9a98-6b0031fcf01c.webp",
        "width": 1181,
        "height": 631
      },
      "poi_business_url": "http://meanyms.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5771863045694363163&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "edmond-s-meany-middle-school",
      "poi_latitude": "47.62182689999999",
      "poi_longitude": "-122.3050484",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-413-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEbcpqSoVkFQRGxbRAtzGGVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_10bb9fc5-fa22-4258-9348-5c2552f1c11a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Morningside Academy",
      "poi_type": "Education",
      "poi_address": "1605 17th Ave, Seattle, WA 98122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-f311-77c9-8c5e-ed0daccd82d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f311-77c9-8c5e-ed0daccd82d9",
        "storage_key": "property/6767906449164267/019dbbe6-f311-77c9-8c5e-ed0daccd82d9.webp",
        "width": 780,
        "height": 520
      },
      "poi_business_url": "https://www.morningsideacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8097904543450708448&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "morningside-academy",
      "poi_latitude": "47.61573019999999",
      "poi_longitude": "-122.31046",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-709-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWdKBBUoVkFQR4LlmGUeJYXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fc009833-76ea-472d-ae20-9cb99794f1e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Garfield High School",
      "poi_type": "Education",
      "poi_address": "400 23rd Ave, Seattle, WA 98122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-f61a-71cf-8b3c-3e6bb03f4ce3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f61a-71cf-8b3c-3e6bb03f4ce3",
        "storage_key": "property/6767906449164267/019dbbe6-f61a-71cf-8b3c-3e6bb03f4ce3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://garfieldhs.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2974457091223332753&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garfield-high-school",
      "poi_latitude": "47.605334",
      "poi_longitude": "-122.301807",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-252-2270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaztWtlYUkFQRkScCEvdkRyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_46650b05-12b8-4940-8b6e-96ba5b5fd9a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Queen Anne Elementary School",
      "poi_type": "Education",
      "poi_address": "2100 4th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-f8e6-770c-8780-d20bda30ccdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f8e6-770c-8780-d20bda30ccdf",
        "storage_key": "property/6767906449164267/019dbbe6-f8e6-770c-8780-d20bda30ccdf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://queenannees.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5903609249051925195&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "queen-anne-elementary-school",
      "poi_latitude": "47.6374085",
      "poi_longitude": "-122.3493473",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-252-2480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-3c57-737d-b9d9-68c16d23d3e8",
        "storage_key": "property/6767906449164267/019d0814-3c57-737d-b9d9-68c16d23d3e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaztWtlYUkFQRy1pzVlXV7VE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_96489efd-8e2c-479c-86ff-608d7d0a41c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Belltown Pickleball Courts",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2600 5th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-fa25-72e9-b37c-508c4f81ccaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-fa25-72e9-b37c-508c4f81ccaa",
        "storage_key": "property/6767906449164267/019dbbe6-fa25-72e9-b37c-508c4f81ccaa.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.seattle.gov/parks/rentals-and-permits/tennis-courts",
      "poi_directions_map_url": "https://maps.google.com/?cid=3676234611308792486&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "belltown-pickleball-courts",
      "poi_latitude": "47.6183218",
      "poi_longitude": "-122.3462874",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt1r9jwYVkFQRpooOxuabBDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_651b0f75-7a40-4a08-b879-db76c0bdadf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Denny Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Dexter Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Park's 4 acres is home to the central offices of the Parks Department, flowers, paths & a play area.",
      "poi_long_description": "Park's 4 acres is home to the central offices of the Parks Department, flowers, paths & a play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-fa69-770f-858b-2d6a44c9b7cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-fa69-770f-858b-2d6a44c9b7cb",
        "storage_key": "property/6767906449164267/019dbbe6-fa69-770f-858b-2d6a44c9b7cb.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/denny-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17697390754654843374&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "denny-park",
      "poi_latitude": "47.619053",
      "poi_longitude": "-122.340936",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41e2-708d-8faa-038b95ee0484",
        "storage_key": "property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7cLUtUkVkFQR7vF7ZiDDmfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_3bc067ef-2ada-4761-ab4a-91dce694c061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "International Fountain",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "305 Harrison St, Seattle, WA 98109, USA",
      "poi_short_description": "This large fountain was built in 1995 & offers a large basin for children to splash in.",
      "poi_long_description": "Visitors say this fountain is a great place to relax, cool off on a sunny day, and enjoy the music and light show. They also highlight the family-friendly atmosphere, with many mentioning it's a fun spot for kids to play.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe6-ff28-76a3-b7ac-4b66f2e05971.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-ff28-76a3-b7ac-4b66f2e05971",
        "storage_key": "property/6767906449164267/019dbbe6-ff28-76a3-b7ac-4b66f2e05971.webp",
        "width": 895,
        "height": 1280
      },
      "poi_business_url": "https://www.seattlecenter.com/explore/attractions/international-fountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=11375305986831424564&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "international-fountain",
      "poi_latitude": "47.6225227",
      "poi_longitude": "-122.3520323",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-684-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKTWVIEQVkFQRNBx2rIY03Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_9962f88c-6d53-4fe4-a498-d03d6797df7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "Lake Union Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "860 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "12-acre lakefront park with boat launch, model-boat pond, Center for Wooden Boats & spray features.",
      "poi_long_description": "People say this city park offers beautiful views of seaplanes, sailboats, and the water, and is a great spot for kayaking, picnicking, and watching fireworks. They highlight the peaceful and relaxing atmosphere, and the convenient parking, including free parking on Sundays and holidays. They also like the nearby coffee shop and museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe7-0303-77ad-8f7a-7f46cae0b114.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe7-0303-77ad-8f7a-7f46cae0b114",
        "storage_key": "property/6767906449164267/019dbbe7-0303-77ad-8f7a-7f46cae0b114.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/lake-union-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021986494381383037&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-union-park",
      "poi_latitude": "47.6277112",
      "poi_longitude": "-122.3368686",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41e2-708d-8faa-038b95ee0484",
        "storage_key": "property/6767906449164267/019d0814-41e2-708d-8faa-038b95ee0484.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbpC3DsVkFQRfV3tymwamMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_96b41276-1e2d-4e7b-a03d-8887265736f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "poi_name": "UpGarden P-Patch Community Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Mercer St, Seattle, WA 98109, USA",
      "poi_short_description": "Urban oasis featuring a variety of plants and flowers atop a parking garage with vista-point views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019dbbe7-03a7-76e1-9ff6-086dd5966559.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe7-03a7-76e1-9ff6-086dd5966559",
        "storage_key": "property/6767906449164267/019dbbe7-03a7-76e1-9ff6-086dd5966559.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://upgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12879108891768204875&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "upgarden-p-patch-community-garden",
      "poi_latitude": "47.625025",
      "poi_longitude": "-122.3500583",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-41a7-72fb-98ea-dfd018415c91",
        "storage_key": "property/6767906449164267/019d0814-41a7-72fb-98ea-dfd018415c91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMR6A1EAVkFQRSy5r9UzJu7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6cb0fc745b1c1803c6a9fb3a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_284fab368ffeea39779bc4c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_09dae5bae91a14e1f7b37ad5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b16bd27e35efdcf7b25bb687",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_95b571034d728f6864497515",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_64632af47da7be15a51c3b0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d2ef84746318f1d19efdeff8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "rating": "5",
      "name": "Victoria",
      "text": "I’ve really enjoyed working & living here so far. The building is well maintained, the staff is friendly and responsive, and the location is super convenient & there are some fun events almost every week. Overall, a great place to live.",
      "date": "2025-07-16",
      "title": "false"
    },
    {
      "id": "ec_c6ca82777515a109e672ef22",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "rating": "5",
      "name": "Sue Bian",
      "text": "I had an incredible experience with Juliane at the leasing office. When FedEx mistakenly delivered my medication to this building (wrong street and unit number) right before Thanksgiving, Juliane went above and beyond to help me retrieve my package. Her understanding and supportive attitude truly made my day. Based on this experience, I can imagine living here would be a pleasant experience with such helpful and caring staff. Thank you, Juliane, for your kindness and professionalism!",
      "date": "2024-11-28",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f1a2c817-971d-4110-82f1-7ed322a42394",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d6cdd-2cbc-7523-a8ec-7e8a29d8e88d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d6cdd-2cbc-7523-a8ec-7e8a29d8e88d",
        "storage_key": "property/6767906449164267/019d6cdd-2cbc-7523-a8ec-7e8a29d8e88d.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "The Century",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=63b3098b4f57c918597bf694"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a3127-334a-7449-a9f5-fde7f5710abc",
      "lead_source": "LANDING_PAGE",
      "name": "The Century landing page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267"
    },
    {
      "lead_collector_id": "019a3127-33e2-7783-89c8-51d1ae780dff",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Century property website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-south-lake-union",
      "search_query": "pet friendly apartments in South Lake Union Seattle",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in South Lake Union",
      "h2_subtitle": "Explore pet-friendly apartments in South Lake Union at The Century. Enjoy amenities like pet-friendly spaces and rooftop views in Seattle.",
      "page_copy": "Welcome to The Century, where pet-friendly apartments in South Lake Union blend style and comfort seamlessly. Nestled in a vibrant Seattle neighborhood, these residences offer everything you and your furry friend need. Enjoy modern amenities such as a high-tech theater and a rooftop deck, perfect for relaxation with your pet. \n\nChoosing The Century means experiencing Seattle living at its finest. Our community is designed keeping pets in mind, offering ample spaces and facilities that ensure both residents and their pets feel at home. With options ranging from cozy studios to expansive three-bedroom units, The Century is the ideal home for pet lovers in South Lake Union.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in South Lake Union",
      "seo_description": "Discover pet-friendly apartments in South Lake Union at The Century, offering modern amenities and stunning views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "seattle-apartments-rooftop-fire-pit",
      "search_query": "Seattle apartments with rooftop fire pit",
      "category": "Amenity",
      "h1_title": "Seattle Apartments with Rooftop Fire Pit",
      "h2_subtitle": "Discover Seattle apartments with a rooftop fire pit at The Century. Enjoy stunning views and modern amenities that elevate your lifestyle.",
      "page_copy": "Experience the best of Seattle living at The Century, where apartments with a rooftop fire pit offer unparalleled comfort and luxury. Nestled in the heart of South Lake Union, our community boasts this unique feature, providing residents with a perfect spot to unwind and enjoy breathtaking views of the city. \n\nAt The Century, modern amenities such as sunken kitchen sinks and a BBQ grill on the rooftop deck enhance your living experience. Whether you're hosting a gathering or relaxing alone, the fire pit creates a cozy atmosphere like no other. Choose from a variety of floor plans, including studios and three-bedroom apartments, each designed with you in mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Seattle Apartments with Rooftop Fire Pit",
      "seo_description": "Find Seattle apartments with a rooftop fire pit at The Century. Enjoy luxury and stunning views in South Lake Union.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "luxury-apartments-high-tech-theater-seattle",
      "search_query": "luxury apartments with high tech theater in Seattle WA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with High-Tech Theater",
      "h2_subtitle": "Discover luxury apartments featuring a high-tech theater in Seattle, WA. The Century offers premium amenities for an elevated lifestyle.",
      "page_copy": "Welcome to The Century where luxury apartments in Seattle, WA are redefined with a high-tech theater and unmatched amenities. Located in the vibrant South Lake Union area, our community is designed for those who appreciate quality and innovation. The high-tech theater provides an immersive entertainment experience, perfect for movie nights or catching the latest shows with friends.\n\nBeyond the theater, The Century offers a host of modern amenities that cater to your lifestyle. Whether enjoying a BBQ on the rooftop deck or relaxing in one of our spacious studios or three-bedroom homes, you will find everything you need right here. Elevate your living experience in one of Seattle's most desirable neighborhoods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with High-Tech Theater",
      "seo_description": "Explore luxury apartments in Seattle with a high-tech theater at The Century, offering premium amenities and modern design.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "rooftop-deck-apartments-near-space-needle",
      "search_query": "rooftop deck apartments near Space Needle Seattle",
      "category": "Amenity",
      "h1_title": "Rooftop Deck Apartments Near Space Needle",
      "h2_subtitle": "Find stunning rooftop deck apartments near the Space Needle in Seattle. Discover breathtaking views and modern living at The Century.",
      "page_copy": "At The Century, enjoy rooftop deck apartments that are just a stone's throw away from the iconic Space Needle in Seattle. Nestled in the vibrant South Lake Union area, our community offers breathtaking views and top-notch amenities. The rooftop deck is the perfect spot to unwind and take in the cityscape or gather with friends around the fire pit.\n\nOur apartments range from charming studios to spacious three-bedroom homes, all designed with modern luxury in mind. The Century's proximity to the Space Needle means easy access to Seattle's top attractions, dining, and entertainment. Experience the best of urban living with a community that prioritizes comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Deck Apartments Near Space Needle",
      "seo_description": "Explore rooftop deck apartments near the Space Needle at The Century in Seattle, offering exceptional views and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "electric-car-charging-station-apartments-seattle",
      "search_query": "electric car charging station apartments Seattle",
      "category": "Amenity",
      "h1_title": "Apartments with Electric Car Charging Stations",
      "h2_subtitle": "Explore Seattle apartments with electric car charging stations. The Century offers convenience and sustainability in the heart of the city.",
      "page_copy": "Step into the future of urban living at The Century, where convenience meets sustainability with electric car charging stations right in Seattle. Located in the bustling South Lake Union neighborhood, our apartments provide the ideal setting for residents who value both environmental consciousness and modern comfort.\n\nThe Century not only embraces green living but also offers a wealth of amenities to enhance your lifestyle. From a rooftop BBQ grill and fire pit to a state-of-the-art theater, there's no shortage of luxury here. Our range of apartment sizes, from cozy studios to expansive three-bedroom homes, ensures you'll find the perfect fit in the heart of Seattle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Electric Car Charging Stations",
      "seo_description": "Discover Seattle apartments with electric car charging stations at The Century, offering green living and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "studio-apartments-south-lake-union",
      "search_query": "studio apartments south lake union seattle",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in South Lake Union",
      "h2_subtitle": "Find chic studio apartments in South Lake Union, Seattle. The Century offers modern amenities and vibrant city living at its best.",
      "page_copy": "Explore the vibrant lifestyle that awaits in South Lake Union with our chic studio apartments at The Century. Perfectly positioned in one of Seattle's most exciting neighborhoods, our studios provide an ideal blend of comfort and modern design. Enjoy sleek interiors with sunken kitchen sinks and ample living space that makes coming home a delight.\n\nLiving at The Century means access to an array of upscale amenities including a rooftop deck with a BBQ grill and a high-tech theater. The location offers easy accessibility to the best of Seattle's dining, shopping, and cultural attractions. Experience the convenience and excitement of urban living in a studio apartment at The Century.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in South Lake Union",
      "seo_description": "Discover studio apartments in South Lake Union at The Century, offering modern amenities and a prime Seattle location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-king-county",
      "search_query": "one bedroom apartments king county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in King County",
      "h2_subtitle": "Explore stylish one bedroom apartments in King County at The Century. Enjoy modern living in a vibrant Seattle location.",
      "page_copy": "Discover the perfect blend of style and convenience with our one bedroom apartments at The Century, located in the heart of King County. Situated in Seattle's lively South Lake Union neighborhood, our community offers an urban oasis with modern amenities tailored to elevate your living experience. \n\nOur one bedroom homes feature thoughtfully designed spaces with contemporary finishes like sunken kitchen sinks. The Century’s amenities include a rooftop deck with a fire pit, a high-tech theater, and pet-friendly conveniences, ensuring you have everything you need right at home. Embrace the vibrant lifestyle and easy access to all of Seattle's attractions with a one bedroom apartment at The Century.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in King County",
      "seo_description": "Explore one bedroom apartments in King County at The Century, offering modern amenities and prime Seattle living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-98109",
      "search_query": "two bedroom apartments in 98109",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in 98109",
      "h2_subtitle": "Discover spacious two bedroom apartments in Seattle's 98109. The Century offers modern living with stunning amenities.",
      "page_copy": "Located in the vibrant zip code 98109, The Century offers expansive two bedroom apartments that perfectly blend style and function. Nestled in Seattle's dynamic South Lake Union, these homes are ideal for those seeking extra space without compromising on modern comforts. With sunken kitchen sinks and high-quality finishes, your apartment is both practical and stylish.\n\nBeyond the walls of your apartment, enjoy amenities designed to enhance your lifestyle. Relax by the rooftop BBQ grill and fire pit, entertain friends in the high-tech theater, or utilize the bicycle work space at The Spoke Shop. Experience the best of Seattle living with the comfort and convenience of a two bedroom apartment at The Century.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in 98109",
      "seo_description": "Find two bedroom apartments in Seattle's 98109 at The Century, offering modern amenities in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-seattle-wa",
      "search_query": "three bedroom apartments seattle wa",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Seattle, WA",
      "h2_subtitle": "Explore spacious three bedroom apartments in Seattle, WA. The Century offers luxury living with exceptional amenities.",
      "page_copy": "Discover the spacious elegance of three bedroom apartments at The Century, located in the bustling city of Seattle, WA. Ideally situated in South Lake Union, these apartments provide ample room for families or roommates seeking luxury and comfort in the heart of the city. Each apartment is thoughtfully designed with modern touches, including sunken kitchen sinks, to meet your lifestyle needs.\n\nThe Century offers an unparalleled living experience with a range of community amenities. Enjoy evenings on the rooftop deck with a fire pit and BBQ grill, or unwind in the high-tech theater. With pet-friendly spaces and a welcoming environment, our three bedroom apartments cater to all. Experience the best of Seattle with The Century as your home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Seattle, WA",
      "seo_description": "Find spacious three bedroom apartments in Seattle, WA at The Century, offering luxury amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-washington-seattle",
      "search_query": "apartments near university of washington seattle",
      "category": "School",
      "h1_title": "Apartments Near University of Washington",
      "h2_subtitle": "Discover modern apartments near the University of Washington. The Century offers convenient living in Seattle’s vibrant neighborhoods.",
      "page_copy": "The Century provides contemporary apartments near the University of Washington in Seattle, offering a seamless blend of comfort and accessibility. Situated in the lively South Lake Union neighborhood, it's the ideal location for students, faculty, or anyone who wishes to enjoy the vibrant Seattle lifestyle while being close to the university.\n\nOur community features an array of amenities tailored for convenience and relaxation. Residents can enjoy the stunning rooftop deck complete with a BBQ grill and fire pit, as well as a high-tech theater and pet-friendly spaces. With stylish interiors and modern finishes, The Century offers the perfect living experience, balancing city life with the comfort of home, just a short distance from the University of Washington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Washington",
      "seo_description": "Explore modern apartments near University of Washington at The Century, offering excellent amenities and a prime Seattle location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-close-to-seattle-central-college-slu",
      "search_query": "apartments close to seattle central college south lake union",
      "category": "School",
      "h1_title": "Apartments Close to Seattle Central College",
      "h2_subtitle": "Find ideal apartments close to Seattle Central College in South Lake Union. The Century offers modern amenities in a vibrant setting.",
      "page_copy": "Located conveniently close to Seattle Central College, The Century in South Lake Union offers the perfect apartment choice for students and professionals alike. Experience the dynamic neighborhood with its vibrant city life while enjoying the tranquility of a thoughtfully designed living space. Our community is perfect for those looking to balance academia with relaxation and entertainment.\n\nThe Century enriches your living experience with top-notch amenities, including a stunning rooftop deck with a BBQ grill and fire pit, a high-tech theater, and a dedicated bicycle workspace. Whether you choose a studio or a three-bedroom apartment, The Century ensures a comfortable and stylish home base, fostering a sense of community right in the heart of Seattle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Seattle Central College",
      "seo_description": "Find apartments near Seattle Central College in South Lake Union at The Century, offering excellent amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-university-wa",
      "search_query": "apartments near seattle university wa",
      "category": "School",
      "h1_title": "Apartments Near Seattle University, WA",
      "h2_subtitle": "Explore modern living with apartments near Seattle University, WA. The Century offers a blend of style and convenience.",
      "page_copy": "Experience the best of Seattle living with The Century's apartments conveniently located near Seattle University, WA. Nestled in the vibrant South Lake Union neighborhood, our community provides a perfect base for students, faculty, and professionals seeking proximity to campus and the excitement of city life. Enjoy the perfect balance of convenience and luxury in a welcoming environment.\n\nThe Century enhances the residential experience with superb amenities, including a barbecue grill and fire pit on the rooftop deck, a pet-friendly atmosphere, and a high-tech theater. Our beautifully designed apartments cater to your lifestyle needs, whether you prefer a cozy studio or a spacious three-bedroom layout. Enjoy modern living just moments from Seattle University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle University, WA",
      "seo_description": "Discover The Century's apartments near Seattle University, WA, combining convenience and modern amenities in bustling South Lake Union.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-close-to-north-seattle-college-king-county",
      "search_query": "apartments close to north seattle college king county",
      "category": "School",
      "h1_title": "Apartments Near North Seattle College",
      "h2_subtitle": "Explore apartments close to North Seattle College in King County. Discover The Century’s modern amenities and convenient location.",
      "page_copy": "The Century presents exceptional apartments close to North Seattle College in King County, offering a unique living experience in a prime location. Our community caters to students and professionals who value easy access to educational opportunities and the vibrant culture of Seattle. Experience the blend of urban living and serene home comforts right here.\n\nAt The Century, residents enjoy a range of amenities designed to enhance their lifestyle, including a rooftop deck equipped with a BBQ grill and fire pit, perfect for relaxing with friends. The community also features a high-tech theater and pet-friendly spaces, ensuring you have everything you need for a comfortable stay. Our varied apartment options, from studios to three-bedroom spaces, provide the flexibility to meet your needs minutes away from North Seattle College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to North Seattle College",
      "seo_description": "Find modern apartments near North Seattle College in King County at The Century, offering fantastic amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-childrens-hospital-slu",
      "search_query": "apartments near Seattle Children's Hospital South Lake Union",
      "category": "Hospital",
      "h1_title": "Apartments Near Seattle Children's Hospital",
      "h2_subtitle": "Discover comfortable apartments near Seattle Children's Hospital in South Lake Union. The Century offers convenience and modern living.",
      "page_copy": "Located in the heart of South Lake Union, The Century offers ideal apartments near Seattle Children's Hospital, providing both comfort and convenience. Perfect for healthcare professionals and hospital visitors, our community is designed to offer a peaceful retreat with quick access to the bustling hospital district and Seattle’s vibrant lifestyle.\n\nAt The Century, residents can enjoy an array of top-tier amenities including a rooftop deck with a BBQ grill and fire pit, perfect for relaxing after a busy day. The community also boasts a high-tech theater and pet-friendly accommodations, allowing you to unwind in style. Choose from a range of floor plans, from intimate studios to expansive three-bedroom apartments, ensuring a perfect fit for your lifestyle and needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle Children's Hospital",
      "seo_description": "Explore The Century's apartments near Seattle Children's Hospital in South Lake Union, offering superb amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "harborview-medical-center-apartments-seattle-wa",
      "search_query": "Harborview Medical Center apartments Seattle WA",
      "category": "Hospital",
      "h1_title": "Apartments Near Harborview Medical Center",
      "h2_subtitle": "Conveniently located near Harborview Medical Center, The Century offers modern apartments in Seattle, WA, with top-notch amenities.",
      "page_copy": "Strategically positioned in Seattle, WA, The Century offers modern apartments near Harborview Medical Center, catering specifically to healthcare professionals, patients, and visitors. Our community provides both the serenity of a refuge away from the hustle and the proximity needed for quick commutes, making it an ideal living solution for those associated with Harborview Medical Center.\n\nThe Century features luxurious amenities designed to enrich your living experience. Relax fireside on our rooftop deck, equipped with a stylish BBQ grill, or enjoy a movie in the high-tech theater after a long shift. With pet-friendly spaces and a variety of apartment layouts, ranging from studios to three-bedroom homes, you are sure to find a place that suits your lifestyle and needs right in the heart of Seattle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Harborview Medical Center",
      "seo_description": "Find ideal apartments near Harborview Medical Center at The Century in Seattle, WA, offering luxury amenities and easy access to the medical district.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-near-gas-works-park-seattle",
      "search_query": "apartments near Gas Works Park Seattle",
      "category": "Park",
      "h1_title": "Apartments Near Gas Works Park",
      "h2_subtitle": "Live near Gas Works Park in Seattle and enjoy The Century's luxurious apartments. Experience modern amenities in a vibrant setting.",
      "page_copy": "Nestled close to the iconic Gas Works Park in Seattle, The Century offers residents a perfect blend of urban living and scenic beauty. Our apartments provide immediate access to one of Seattle's most cherished green spaces, ideal for picnics, outdoor activities, and stunning views of the city skyline. Experience the best of both worlds with nature and city life at your doorstep.\n\nAt The Century, explore an array of amenities designed to elevate your lifestyle. Spend evenings relaxing on the rooftop deck complete with a BBQ grill and fire pit, or catch the latest film in our state-of-the-art theater. With an array of floor plans from cozy studios to spacious three-bedroom homes, you're sure to find the perfect space to call home, right near the vibrant setting of Gas Works Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gas Works Park",
      "seo_description": "Discover The Century's apartments near Gas Works Park in Seattle, where modern amenities meet the charm of one of the city's iconic green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "kerry-park-nearby-apartments-south-lake-union",
      "search_query": "Kerry Park nearby apartments South Lake Union",
      "category": "Park",
      "h1_title": "Kerry Park Nearby Apartments",
      "h2_subtitle": "Explore modern apartments near Kerry Park in South Lake Union. The Century offers luxury living with stunning views and top-notch amenities.",
      "page_copy": "Situated in the vibrant South Lake Union neighborhood, The Century provides the ideal living destination for those seeking apartments near Kerry Park. Known for its breathtaking panoramic views of the Seattle skyline, Kerry Park is a short trip away, offering residents the perfect spot for evening strolls and stunning sunsets. Enjoy easy access to Seattle's lively cultural scene and favorite local spots.\n\nThe Century presents an exceptional living experience with its modern amenities tailored for comfort and convenience. You'll enjoy our rooftop deck with a BBQ grill and fire pit, the perfect place to unwind after exploring Kerry Park. Pet-friendly accommodations and a high-tech theater are just some of the features that make The Century a sought-after choice. Whether you prefer a cozy studio or need space with one of our three-bedroom options, you'll find a home that suits your lifestyle at The Century.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kerry Park Nearby Apartments",
      "seo_description": "Live near Kerry Park at The Century in South Lake Union, where luxurious amenities meet scenic Seattle views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "golden-gardens-park-apartments-in-king-county",
      "search_query": "Golden Gardens Park apartments in King County",
      "category": "Park",
      "h1_title": "Apartments Near Golden Gardens Park",
      "h2_subtitle": "Discover spacious apartments near Golden Gardens Park in King County, where The Century offers exceptional amenities and scenic living.",
      "page_copy": "Located in the heart of King County, The Century offers a unique living experience near the popular Golden Gardens Park. Known for its sandy beach and stunning sunsets, Golden Gardens is just a quick trip away, providing a relaxing escape whenever you crave the natural beauty of the Pacific Northwest. Our proximity to this beloved park makes The Century an ideal choice for those who appreciate outdoor living without compromising on urban convenience.\n\nThe Century delivers first-class amenities designed to enhance your comfort. Enjoy panoramic views from our rooftop deck, complete with a BBQ grill and fire pit, or get some wind in your hair with the on-site bicycle work space and storage. Choose from a variety of layouts, ranging from intimate studios to expansive three-bedroom apartments, ensuring that you find the perfect fit for your lifestyle, all while being close to the serene beauty of Golden Gardens Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Golden Gardens Park",
      "seo_description": "Find your home near Golden Gardens Park at The Century in King County, offering modern amenities and easy access to Seattle's best natural attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "discovery-park-area-apartments-seattle",
      "search_query": "Discovery Park area apartments Seattle",
      "category": "Park",
      "h1_title": "Discovery Park Area Apartments",
      "h2_subtitle": "Find ideal apartments near Discovery Park in Seattle at The Century, where city living meets natural beauty with top-notch amenities.",
      "page_copy": "Positioned conveniently in Seattle, The Century presents the perfect option for those seeking apartments near Discovery Park. Embrace the best of outdoor and urban living with this iconic park just minutes away, offering miles of trails and stunning views of Puget Sound. The Century provides easy access to Discovery Park's serene landscapes while being located in the lively South Lake Union neighborhood.\n\nExperience unparalleled amenities at The Century, where luxurious living spaces are complemented by modern features. Relax on our rooftop deck featuring a BBQ grill and fire pit, perfect for gathering with friends after a day at Discovery Park. Choose from a diverse array of floor plans, including stylish studios and spacious three-bedroom layouts, all designed to enhance your lifestyle. At The Century, discover the perfect balance between comfort and proximity to Seattle’s natural allure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Discovery Park Area Apartments",
      "seo_description": "Live near Discovery Park at The Century in Seattle, offering luxury apartments and stunning amenities in a vibrant urban setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "olympic-sculpture-park-nearby-apartments-98109",
      "search_query": "Olympic Sculpture Park nearby apartments 98109",
      "category": "Park",
      "h1_title": "Apartments Near Olympic Sculpture Park",
      "h2_subtitle": "Discover stylish apartments near Olympic Sculpture Park within the 98109 area at The Century, offering modern amenities and an artistic lifestyle.",
      "page_copy": "Located in Seattle's vibrant 98109 area, The Century offers upscale living just steps from the renowned Olympic Sculpture Park. This unique outdoor space, filled with impressive art installations and breathtaking views of Elliott Bay, is a favorite among locals and visitors alike. Living at The Century, you'll have convenient access to this cultural treasure, enriching your Seattle experience with both nature and art.\n\nThe Century brings you a blend of modern living and thoughtful amenities. Our residents enjoy an exceptional rooftop deck featuring a BBQ grill and fire pit—perfect for relaxing after exploring Olympic Sculpture Park. With options ranging from cozy studios to expansive three-bedroom apartments, you're sure to find the perfect fit for your needs. Plus, with additional features like a bicycle workspace and sunken kitchen sinks, living at The Century enhances every aspect of urban life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Olympic Sculpture Park Nearby Apartments",
      "seo_description": "Live by Olympic Sculpture Park in Seattle's 98109 at The Century, where art meets comfort in luxurious apartments with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-near-westlake-seattle",
      "search_query": "apartments near Westlake Seattle",
      "category": "Transit",
      "h1_title": "Apartments Near Westlake Seattle",
      "h2_subtitle": "Experience premier living in apartments near Westlake in Seattle. The Century offers comfort steps away from vibrant downtown life and dining.",
      "page_copy": "The Century offers sophisticated urban living within close proximity to Seattle's bustling Westlake area. This prime location places you in the heart of the city, surrounded by shopping, dining, and entertainment options. Whether you're exploring the dynamic downtown scene or unwinding in the tranquility of your luxury apartment, The Century provides the best of both worlds.\n\nOur community features spacious layouts with top-tier amenities, including a rooftop deck equipped with a BBQ grill and fire pit—ideal for gatherings with friends. Residents also benefit from a convenient bicycle workspace and online rental payments. Choose from elegant studios or more expansive three-bedroom plans, each designed with comfort in mind. Living near Westlake means enjoying easy access to the city's vibrant atmosphere while residing in a peaceful retreat at The Century.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Westlake Seattle",
      "seo_description": "Find luxury apartments near Westlake at The Century in Seattle, offering modern amenities and prime downtown access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-close-to-u-district-wa",
      "search_query": "apartments close to U District WA",
      "category": "Transit",
      "h1_title": "Apartments Close to U District WA",
      "h2_subtitle": "Explore modern living in apartments close to U District WA. Discover The Century, offering top amenities and convenient access to Seattle's cultural hub.",
      "page_copy": "Situated a short drive from the vibrant University District, The Century in Seattle offers an ideal location for those seeking apartments close to U District, WA. Known for its eclectic mix of cafes, shops, and cultural events, the U District is a dynamic area catering to students, professionals, and families alike. At The Century, enjoy easy access to this lively neighborhood while retreating to your spacious, amenity-rich home.\n\nOur community provides a unique blend of relaxation and convenience with features like a rooftop deck that includes a BBQ grill and fire pit, perfect for socializing or unwinding. The Century caters to diverse lifestyles with its selection of modern studios to expansive three-bedroom apartments. Whether you're studying, working, or simply enjoying the city, living near the U District means vibrant community life is always at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to U District WA",
      "seo_description": "The Century offers luxury living near U District, WA, combining modern amenities with proximity to Seattle's lively university area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-by-university-of-washington-station",
      "search_query": "apartments by University of Washington Station",
      "category": "Transit",
      "h1_title": "Apartments by University of Washington Station",
      "h2_subtitle": "Find premium apartments by University of Washington Station. The Century offers modern amenities and easy transit access in Seattle.",
      "page_copy": "The Century in Seattle provides an exceptional living experience just a transit ride away from the University of Washington Station. Nestled in a prime location, our community offers seamless access to the UW campus, making it ideal for students and faculty. With the light rail station nearby, commuting throughout the city is a breeze, connecting you quickly to academic, cultural, and recreational activities.\n\nOur residents enjoy the comfort of modern homes with features like a rooftop deck complete with a BBQ grill and communal fire pit, perfect for relaxation or entertainment. The Century offers floor plans ranging from intimate studios to large three-bedroom apartments, ensuring a perfect fit for every lifestyle. Additionally, amenities such as a bicycle workspace and sunken kitchen sinks add convenience to your daily routine. At The Century, experience the perfect blend of city living and academic proximity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by University of Washington Station",
      "seo_description": "Discover The Century's luxury apartments by University of Washington Station, combining convenience with modern amenities in Seattle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-near-symphony-south-lake-union",
      "search_query": "apartments near Symphony South Lake Union",
      "category": "Transit",
      "h1_title": "Apartments Near Symphony South Lake Union",
      "h2_subtitle": "Discover luxury living in apartments near Symphony in South Lake Union. The Century offers unmatched comfort and style in a vibrant Seattle neighborhood.",
      "page_copy": "Located in the dynamic neighborhood of South Lake Union, The Century offers exquisite apartments near Symphony, providing a perfect blend of luxury and convenience. This area is renowned for its vibrant cultural scene, including the Symphony, which draws music lovers from across the city. Living at The Century, you’ll be just moments away from a symphony of experiences, from fine dining to exciting shopping.\n\nOur residents enjoy a host of premium amenities, such as a rooftop deck with a BBQ grill and a cozy fire pit—ideal settings for relaxing or socializing. Choose from a variety of living spaces, including cozy studios and spacious three-bedroom units, all designed with contemporary finishes and features such as sunken kitchen sinks. Experience the best of South Lake Union, where city excitement meets the comfort of home at The Century.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Symphony South Lake Union",
      "seo_description": "Find upscale apartments near Symphony in South Lake Union at The Century, combining style and convenience in Seattle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164267",
      "source": "generator",
      "page_item_url": "apartments-close-to-king-county-international-airport",
      "search_query": "apartments close to King County International Airport",
      "category": "Transit",
      "h1_title": "Apartments Close to King County International Airport",
      "h2_subtitle": "Discover convenient living with apartments close to King County International Airport. The Century offers modern amenities and easy access to travel.",
      "page_copy": "The Century offers the ideal solution for those seeking apartments close to King County International Airport, combining modern living with travel convenience. Situated in Seattle, our vibrant community makes commuting a breeze, perfect for frequent flyers or airport employees. This strategic location ensures you're always connected to key travel hubs while enjoying city life. \n\nAt The Century, you’ll find a suite of top-tier amenities, including a scenic rooftop deck complete with a BBQ grill and fire pit, ideal spaces for relaxation after a long flight. Our selection of homes ranges from stylish studios to expansive three-bedroom apartments, each fitted with contemporary features like sunken kitchen sinks. With the convenience of online rental payments and dedicated bicycle storage, The Century merges the ease of travel with the comfort of modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
      "featured_image_media": {
        "alt_text": "The Century building exterior with a prominent sign above the entrance.",
        "public_id": "019d0813-581d-71ca-adea-12db25190dab",
        "storage_key": "property/6767906449164267/019d0813-581d-71ca-adea-12db25190dab.webp",
        "width": 2000,
        "height": 500
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to King County International Airport",
      "seo_description": "Live near King County International Airport at The Century, featuring modern amenities and easy travel access in Seattle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4932"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9241077882"
    },
    {
      "ID": "custom_pay_rent_url",
      "type": "STRING",
      "value": "https://www.biltrewards.com/paywithbilt/login/phone"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NN8B49K8"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"https://webchat.omni.cafe/conversations/d615603b-f1c1-42a2-8093-474f18198ff5/app.js?property=d615603b-f1c1-42a2-8093-474f18198ff5&propertyName=The+Century&channelUuid=c0a15f7f-7c1c-11eb-8904-42010aa8d42b\" defer></script>"
    },
    {
      "ID": "custom_engrain_sitemap_id",
      "type": "STRING",
      "value": "6m9pzmjzvk1"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "49265269316"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/6m9pzmjzvk1"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "417-318-4693"
    },
    {
      "ID": "custom_seattle_income_limits_url",
      "type": "STRING",
      "value": "https://www.seattle.gov/housing/property-managers/income-and-rent-limits#multifamilypropertytaxexemptionmfteprogram"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlZTWWtoNXF4YnhtRFdhOVdJZjJjaVE9PSIsInZhbHVlIjoiajlDNU1hZitlY2ZhNmZRcFVBKzkzQT09IiwibWFjIjoiNmJmNDM4NDI1MjM5MzM0YmNjZDY0YWU5Yzg0M2M0NWI1NDFjOGQ5ZjZkOTgwYzYwNDI2OGQ1MmYwZTMxNjg5NiJ9"
    },
    {
      "ID": "custom_pillar_properties_guarantee",
      "type": "STRING",
      "value": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple."
    },
    {
      "ID": "custom_seattle_income_qualified_blurb",
      "type": "STRING",
      "value": "The Century participates in the City of Seattle Multifamily Property Tax Exemption (MFTE) Program to provide income- and rent-restricted apartments to those who qualify. The floor plans below represent the select homes at The Century that are part of the program at the 80% average median income rent range for studios and one bedrooms, and 90% for two bedrooms.  These homes are available to low to moderate income households, with specific income requirements dependent on the size of the household and the number of bedrooms. These homes are open to all prospective residents that meet the property’s rental screening criteria and are determined to be income eligible for the MFTE program.  For information on current income limits, click HERE to see if you are eligible.      Rental prices listed below do not include utilities or additional costs such as parking, pets, and storage.    · Studios - $1,595 · Open One Bedroom - $1,797 · One Bedroom - $1,797 · Two Bedroom - $2,395   Please contact the Leasing Office to learn more and apply!  By supporting mixed-income residential development in the urban centers, the MFTE program ensures affordability as the Seattle community grows."
    },
    {
      "ID": "custom_pillar_properties_screening_criteria",
      "type": "STRING",
      "value": "https://multihubmedia.com/company/5767906449162415/019db50d-a861-71cb-ad54-c25f173da80c.pdf"
    },
    {
      "ID": "custom_pillar_properties_guarantee_disclaimer",
      "type": "STRING",
      "value": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
    }
  ],
  "custom_qb_id": "4932",
  "custom_repli_id": "9241077882",
  "custom_pay_rent_url": "https://www.biltrewards.com/paywithbilt/login/phone",
  "custom_google_gtm_id": "GTM-NN8B49K8",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"https://webchat.omni.cafe/conversations/d615603b-f1c1-42a2-8093-474f18198ff5/app.js?property=d615603b-f1c1-42a2-8093-474f18198ff5&propertyName=The+Century&channelUuid=c0a15f7f-7c1c-11eb-8904-42010aa8d42b\" defer></script>",
  "custom_engrain_sitemap_id": "6m9pzmjzvk1",
  "custom_hubspot_company_id": "49265269316",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/6m9pzmjzvk1",
  "custom_ppc_tracking_phone_number": "417-318-4693",
  "custom_seattle_income_limits_url": "https://www.seattle.gov/housing/property-managers/income-and-rent-limits#multifamilypropertytaxexemptionmfteprogram",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlZTWWtoNXF4YnhtRFdhOVdJZjJjaVE9PSIsInZhbHVlIjoiajlDNU1hZitlY2ZhNmZRcFVBKzkzQT09IiwibWFjIjoiNmJmNDM4NDI1MjM5MzM0YmNjZDY0YWU5Yzg0M2M0NWI1NDFjOGQ5ZjZkOTgwYzYwNDI2OGQ1MmYwZTMxNjg5NiJ9",
  "custom_pillar_properties_guarantee": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple.",
  "custom_seattle_income_qualified_blurb": "The Century participates in the City of Seattle Multifamily Property Tax Exemption (MFTE) Program to provide income- and rent-restricted apartments to those who qualify. The floor plans below represent the select homes at The Century that are part of the program at the 80% average median income rent range for studios and one bedrooms, and 90% for two bedrooms.  These homes are available to low to moderate income households, with specific income requirements dependent on the size of the household and the number of bedrooms. These homes are open to all prospective residents that meet the property’s rental screening criteria and are determined to be income eligible for the MFTE program.  For information on current income limits, click HERE to see if you are eligible.      Rental prices listed below do not include utilities or additional costs such as parking, pets, and storage.    · Studios - $1,595 · Open One Bedroom - $1,797 · One Bedroom - $1,797 · Two Bedroom - $2,395   Please contact the Leasing Office to learn more and apply!  By supporting mixed-income residential development in the urban centers, the MFTE program ensures affordability as the Seattle community grows.",
  "custom_pillar_properties_screening_criteria": "https://multihubmedia.com/company/5767906449162415/019db50d-a861-71cb-ad54-c25f173da80c.pdf",
  "custom_pillar_properties_guarantee_disclaimer": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
};

export const generatedAt = '2026-09-29T17:39:45.163Z';
